import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** Any JSON scalar */
  JSONScalar: any;
};

/** Type of user */
export enum AppliedByType {
  Web = 'WEB',
  Admin = 'ADMIN',
  Whatsapp = 'WHATSAPP',
  System = 'SYSTEM',
  Pipeline = 'PIPELINE',
  Phone = 'PHONE',
  AiAgent = 'AI_AGENT'
}

export type AuthUser = {
  __typename?: 'AuthUser';
  user: User;
  access: Scalars['String'];
};

/** Type of Bank */
export enum BankType {
  BancoDavivienda = 'BANCO_DAVIVIENDA',
  BancoDeBogota = 'BANCO_DE_BOGOTA',
  Bbva = 'BBVA',
  Claro = 'CLARO',
  MovistarMoney = 'MOVISTAR_MONEY',
  NoBank = 'NO_BANK',
  Pichincha = 'PICHINCHA',
  Rappipay = 'RAPPIPAY',
  RappiPrestamo = 'RAPPI_PRESTAMO',
  Scotiabank = 'SCOTIABANK',
  Tranquiapp = 'TRANQUIAPP',
  Itau = 'ITAU',
  LuloBank = 'LULO_BANK',
  Bancolombia = 'BANCOLOMBIA',
  Avvillas = 'AVVILLAS',
  Tuya = 'TUYA',
  Occidente = 'OCCIDENTE',
  Santander = 'SANTANDER',
  Helm = 'HELM',
  Hsbc = 'HSBC',
  Falabella = 'FALABELLA',
  Corpbanca = 'CORPBANCA',
  Bcp = 'BCP',
  BancoW = 'BANCO_W',
  Cencosud = 'CENCOSUD',
  Daviplata = 'DAVIPLATA',
  BancoPopular = 'BANCO_POPULAR',
  Bancien = 'BANCIEN',
  BancoDelEstado = 'BANCO_DEL_ESTADO',
  Banistmo = 'BANISTMO',
  Cmr = 'CMR',
  Gyf = 'GYF',
  Nubank = 'NUBANK',
  Refinancia = 'REFINANCIA',
  Citibank = 'CITIBANK'
}

/** Tipos de bloqueo de producto */
export enum BlockType {
  Temporary = 'TEMPORARY',
  Permanent = 'PERMANENT'
}

/** Type of Brand */
export enum BrandType {
  Beta = 'BETA',
  Tranquiapp = 'TRANQUIAPP',
  TranquiNegociador = 'TRANQUI_NEGOCIADOR',
  Jcap = 'JCAP',
  Apex = 'APEX',
  Pra = 'PRA'
}

export type ClaroCampaign = {
  __typename?: 'ClaroCampaign';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  discount: Scalars['Float'];
};

/** Operation country */
export enum Country {
  Co = 'CO',
  Mx = 'MX'
}

/** Currency type */
export enum Currency {
  Cop = 'Cop',
  Usd = 'Usd',
  Mxn = 'Mxn'
}


/** Debt manager */
export enum DebtManager {
  Tranquiapp = 'TRANQUIAPP',
  BancoDavivienda = 'BANCO_DAVIVIENDA',
  Bbva = 'BBVA',
  Rappipay = 'RAPPIPAY',
  RappiPrestamo = 'RAPPI_PRESTAMO',
  Pichincha = 'PICHINCHA',
  MovistarMoney = 'MOVISTAR_MONEY',
  Beta = 'BETA',
  Apex = 'APEX',
  Pra = 'PRA'
}

/** Valid debt types */
export enum DebtType {
  CreditCard = 'CREDIT_CARD',
  Mortgage = 'MORTGAGE',
  Vehicle = 'VEHICLE',
  Leasing = 'LEASING',
  AllPurpose = 'ALL_PURPOSE',
  Payroll = 'PAYROLL',
  Revolving = 'REVOLVING',
  Informal = 'INFORMAL',
  Services = 'SERVICES',
  Virtual = 'VIRTUAL',
  PayrollAdvance = 'PAYROLL_ADVANCE',
  Unclassified = 'UNCLASSIFIED',
  Overdraft = 'OVERDRAFT',
  Housing = 'HOUSING',
  Rediscount = 'REDISCOUNT',
  Factoring = 'FACTORING',
  ConsumerLoan = 'CONSUMER_LOAN',
  CommercialLoan = 'COMMERCIAL_LOAN',
  Bscs = 'BSCS',
  Rr = 'RR',
  Sga = 'SGA',
  Ascard = 'ASCARD',
  Flexicuota = 'FLEXICUOTA'
}

/** Days behind exposition (Exposición de Mora) */
export enum ExmType {
  Zero = 'ZERO',
  Thirty = 'THIRTY',
  Sixty = 'SIXTY',
  Ninety = 'NINETY',
  OneHundredTwenty = 'ONE_HUNDRED_TWENTY',
  OneHundredFifty = 'ONE_HUNDRED_FIFTY',
  OneHundredEighty = 'ONE_HUNDRED_EIGHTY',
  TwoHundredTen = 'TWO_HUNDRED_TEN',
  TwoHundredForty = 'TWO_HUNDRED_FORTY',
  TwoHundredSeventy = 'TWO_HUNDRED_SEVENTY',
  ThreeHundredSixty = 'THREE_HUNDRED_SIXTY',
  ThreeHundredSixtyOne = 'THREE_HUNDRED_SIXTY_ONE'
}

export type EntityCallInfo = {
  __typename?: 'EntityCallInfo';
  /** The phone number for calls in international format. */
  number: Scalars['String'];
  /** The phone number formatted for display. */
  formattedNumber: Scalars['String'];
};

export type EntitySelector = {
  __typename?: 'EntitySelector';
  /** Bank name. */
  bank: BankType;
  /** Brand name. */
  brand: BrandType;
  /** The country associated with the entity. */
  country: Country;
};

export type EntityWhatsappInfo = {
  __typename?: 'EntityWhatsappInfo';
  /** The WhatsApp phone number in international format. */
  number: Scalars['String'];
  /** The WhatsApp phone number formatted for display. */
  formattedNumber: Scalars['String'];
};

export type FinalAssignmentDate = {
  __typename?: 'FinalAssignmentDate';
  /** Date for final assignment */
  regularDate: Scalars['DateTime'];
  /** Date for final assignment for punished debts */
  prePunishedDate?: Maybe<Scalars['DateTime']>;
  /** DEPRECATED - Date for final assignment for special total payment */
  specialDate?: Maybe<Scalars['DateTime']>;
  /** Bank for the final assignment */
  bank: BankType;
  /** Brand for the final assignment */
  brand: BrandType;
  /** Description text */
  description?: Maybe<Scalars['String']>;
  /** Max date until we receive Payments */
  maxValidPaymentDate: Scalars['DateTime'];
};

export type GlobalSettingByEntity = {
  __typename?: 'GlobalSettingByEntity';
  /** Entity Info */
  entitySelector: EntitySelector;
  /** WhatsApp  numbers */
  domainWhatsapp: EntityWhatsappInfo;
  /** Call numbers */
  domainCalls?: Maybe<EntityCallInfo>;
  domainMaintenance?: Maybe<MaintenanceConfig>;
};

export type IdentityConfirmationOption = {
  __typename?: 'IdentityConfirmationOption';
  /** type enum */
  type: IdentityConfirmationOptionType;
  id: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Scalars['JSONScalar']>>;
  /** if it's a CC or another bank product */
  bank?: Maybe<BankType>;
  /** Number of validation attempts remaining for this option */
  remainingAttempts?: Maybe<Scalars['Float']>;
  /** Whether all attempts for this option have been exhausted */
  attemptsExhausted?: Maybe<Scalars['Boolean']>;
};

/** IdentityConfirmationOptionType name */
export enum IdentityConfirmationOptionType {
  CcNumber = 'CCNumber',
  Cellphone = 'Cellphone',
  Email = 'Email',
  DeepLink = 'DeepLink',
  OneTimeLink = 'ONE_TIME_LINK'
}

export type IdentityValidationBlock = {
  __typename?: 'IdentityValidationBlock';
  tries: Scalars['Float'];
  until: Scalars['Float'];
};

export type InputNegotiationExtraInfo = {
  reason?: Maybe<Scalars['String']>;
  reasonOther?: Maybe<Scalars['String']>;
  economic?: Maybe<Scalars['String']>;
  economicOther?: Maybe<Scalars['String']>;
  creditCardOption?: Maybe<Scalars['Boolean']>;
  newPaymentDay?: Maybe<Scalars['Float']>;
  cancelCheckbox?: Maybe<Scalars['Boolean']>;
  acceptCheckbox?: Maybe<Scalars['Boolean']>;
  appliedBy?: Maybe<Scalars['String']>;
  /** PaymentDate */
  paymentDate?: Maybe<Scalars['DateTime']>;
  /** maxPaymentDate */
  maxPaymentDate?: Maybe<Scalars['DateTime']>;
  age?: Maybe<Scalars['String']>;
  salary?: Maybe<Scalars['String']>;
  monthlyPayments?: Maybe<Scalars['String']>;
  extraIncomeEconomic?: Maybe<Scalars['String']>;
  extraIncome?: Maybe<Scalars['String']>;
  declaredIncome?: Maybe<Scalars['String']>;
  declaredPaymentCapacity?: Maybe<Scalars['String']>;
};

export type InputNegotiationOption = {
  /** type enum */
  type: NegotiationType;
  /** alternatives list */
  alternatives: Array<InputNegotiationOptionAlternative>;
  /** is this negotiation option available? */
  available: Scalars['Boolean'];
  /** extra info for why is this option not available or other important info for the user */
  hint?: Maybe<Scalars['String']>;
  availableGracePeriods: Array<Scalars['Int']>;
  /** should auto continue / redirect to next step (PaymentPromise and NoOptions) */
  autoContinue: Scalars['Boolean'];
  /** requirements for acceptance of option ( cuando es mayor a 14M debe llenar una información extra ) */
  extraConfirmationInfo?: Maybe<NegotiationOptionExtraConfirmationInfoType>;
  /** own rate of negotiation option */
  rate?: Maybe<Scalars['Float']>;
  /** this field is related with ACPK Davivienda alternative */
  validUntil?: Maybe<Scalars['DateTime']>;
  /** is this option pre-calculated by the bank, or calculated by us */
  isPreCalculated?: Maybe<Scalars['Boolean']>;
  /** settings for the frontend */
  settings?: Maybe<InputNegotiationOptionSettings>;
};

export type InputNegotiationOptionAlternative = {
  /** term of alternative (total months to pay) */
  term: Scalars['Float'];
  /** value (monthly amount to pay) */
  value: Scalars['Float'];
  /** currency type for this alternative */
  currency: Currency;
  /** grace period (months without pay) */
  gracePeriod?: Maybe<Scalars['Float']>;
  /** is this alternative available? */
  available: Scalars['Boolean'];
  /** extra info for why is it not available or other important info for the user */
  hint?: Maybe<Scalars['String']>;
  /** discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  discountValue?: Maybe<Scalars['Float']>;
  /** real discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  realDiscountValue?: Maybe<Scalars['Float']>;
  /** real discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  realDiscountPercent?: Maybe<Scalars['Float']>;
  /** discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  discountPercent?: Maybe<Scalars['Float']>;
  /** for some negotiation options (cancelación total) the total balance has a discount depending on the alternative */
  balance?: Maybe<Scalars['Float']>;
  /** some negotiations need some pre payment from the user (Abono mínimo para poder efectuar negociación) */
  prePayment?: Maybe<Scalars['Float']>;
  /** BBVA: valor del extracupo cuando aplica (snapshot del último assignment), pre-calculated so the front only shows it */
  extracupo?: Maybe<Scalars['Float']>;
  /** BBVA: pago inicial total (prePayment + extracupo) cuando aplica, pre-calculated so the front only shows it */
  totalInitialPayment?: Maybe<Scalars['Float']>;
  /** should this alternative be hidden (initially) */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Type of alternative regarding how much balance is covered. */
  type?: Maybe<NegotiationOptionAlternativeType>;
  /** Commission percent applied to alternative value. */
  commissionPercent?: Maybe<Scalars['Float']>;
  /** Commission value applied to alternative value. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** Monthly interest rate i = (1+EA)^(1/12) - 1 */
  interestsRate?: Maybe<Scalars['Float']>;
  /** Effective annual rate EA used to compute installments */
  effectiveAnnualRate?: Maybe<Scalars['Float']>;
  /** Discount fraction applied to mora interests INTERES_MORA (0–1) */
  discountMora?: Maybe<Scalars['Float']>;
  /** Total amount to pay for this alternative */
  totalAmountToPay?: Maybe<Scalars['Float']>;
  /** Custom negotiation created by an admin */
  isCustomNegotiation?: Maybe<Scalars['Boolean']>;
  /** Special campaign alternative created by an admin */
  isSpecialCampaign?: Maybe<Scalars['Boolean']>;
};

export type InputNegotiationOptionSettings = {
  /** minimum value for user defined prePayment */
  min?: Maybe<Scalars['Float']>;
  /** maximum value for user defined prePayment */
  max?: Maybe<Scalars['Float']>;
  /** step for user defined prePayment input */
  step?: Maybe<Scalars['Float']>;
  /** Whether term extension requires document signing (BdB only) */
  isDocumentalTermExtension?: Maybe<Scalars['Boolean']>;
  /** is the prePayment input available? */
  withPrePaymentInput?: Maybe<Scalars['Boolean']>;
  /** max payment date for new negotiation pre payment */
  maxPaymentDate?: Maybe<Scalars['DateTime']>;
  /** id of parent debt to search for the same negotiation type, in case of a virtual debt */
  parentOptionDebt?: Maybe<Scalars['String']>;
  /** Is this child option only a shortcut to the parent option, or should it be a valid option in itself? */
  isShortcutToParent?: Maybe<Scalars['Boolean']>;
};


export type LegalAcceptanceVersion = {
  __typename?: 'LegalAcceptanceVersion';
  termsAndConditions?: Maybe<Scalars['String']>;
  dataProcessingPolicy?: Maybe<Scalars['String']>;
};

export type MaintenanceConfig = {
  __typename?: 'MaintenanceConfig';
  enableRunMaintenance?: Maybe<Scalars['Boolean']>;
};

export type ManagedBank = {
  __typename?: 'ManagedBank';
  brand: BrandType;
  debtManager: DebtManager;
  bank: BankType;
};

export type Mutation = {
  __typename?: 'Mutation';
  newWaChatEvent: Scalars['Boolean'];
  createNegotiation: Negotiation;
  updateMaxPaymentDateExpiredNegotiation?: Maybe<Scalars['String']>;
  /**
   * If it is possible to
   *   apply soft delete, it returns id of negotiation. Otherwise, return null
   */
  deleteExpiredNegotiation?: Maybe<Scalars['String']>;
  updatePhone: Scalars['Boolean'];
  newTwilioPhoneVerification: TwilioPhoneVerification;
  twilioPhoneVerification: AuthUser;
  unvalidateTwilioVerification: Scalars['Boolean'];
  acceptLegalTerms?: Maybe<User>;
  confirmIdentityCCNumber: AuthUser;
  confirmIdentityEmail: AuthUser;
  confirmIdentityDeepLink: AuthUser;
  confirmIdentityOneTimeLink: AuthUser;
  confirmIdentityAdmin: AuthUser;
};


export type MutationCreateNegotiationArgs = {
  extraInfo: InputNegotiationExtraInfo;
  alternative: InputNegotiationOptionAlternative;
  negotiationType: Scalars['String'];
  negotiationOption: InputNegotiationOption;
  bank: Scalars['String'];
  outDebtId: Scalars['String'];
};


export type MutationUpdateMaxPaymentDateExpiredNegotiationArgs = {
  maxPaymentDate: Scalars['DateTime'];
  negotiationId: Scalars['String'];
};


export type MutationDeleteExpiredNegotiationArgs = {
  negotiationId: Scalars['String'];
};


export type MutationUpdatePhoneArgs = {
  phone: Scalars['String'];
};


export type MutationNewTwilioPhoneVerificationArgs = {
  type?: Maybe<Scalars['String']>;
  digits?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};


export type MutationTwilioPhoneVerificationArgs = {
  dataProcessing?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
  bank: Scalars['String'];
  brand: Scalars['String'];
  code: Scalars['String'];
};


export type MutationAcceptLegalTermsArgs = {
  dataProcessing?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
};


export type MutationConfirmIdentityCcNumberArgs = {
  dataProcessing?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
  bank: Scalars['String'];
  brand: Scalars['String'];
  digits: Scalars['String'];
};


export type MutationConfirmIdentityEmailArgs = {
  dataProcessing?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
  bank: Scalars['String'];
  brand: Scalars['String'];
  value: Scalars['String'];
};


export type MutationConfirmIdentityDeepLinkArgs = {
  userId: Scalars['String'];
  token: Scalars['String'];
  bank: Scalars['String'];
};


export type MutationConfirmIdentityOneTimeLinkArgs = {
  id: Scalars['String'];
};


export type MutationConfirmIdentityAdminArgs = {
  bank: Scalars['String'];
  brand: Scalars['String'];
};

/** This entity is only responsible for saving negotaitons and their states */
export type Negotiation = {
  __typename?: 'Negotiation';
  id: Scalars['String'];
  /** Relation with outDebt. It must be a string */
  outDebtId: Scalars['String'];
  /** bank/creditor */
  bank: BankType;
  /** State of Negotiation */
  state: NegotiationState;
  /** Type Negotiation */
  type: NegotiationType;
  /** Alternative chosen */
  alternative: NegotiationOptionAlternative;
  negotiationOption: NegotiationOption;
  /** extra data */
  extra: NegotiationExtra;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type NegotiationExtra = {
  __typename?: 'NegotiationExtra';
  /** Date when negotiation was sent to the bank */
  sentDate?: Maybe<Scalars['DateTime']>;
  /** combined key for virtual OutDebt */
  virtualId?: Maybe<Scalars['String']>;
  /** Payment if user do it */
  payment?: Maybe<Scalars['Float']>;
  /** extra info from Frontend */
  info?: Maybe<NegotiationExtraInfo>;
};

export type NegotiationExtraInfo = {
  __typename?: 'NegotiationExtraInfo';
  reason?: Maybe<Scalars['String']>;
  reasonOther?: Maybe<Scalars['String']>;
  economic?: Maybe<Scalars['String']>;
  economicOther?: Maybe<Scalars['String']>;
  newPaymentDay?: Maybe<Scalars['Float']>;
  cancelCheckbox?: Maybe<Scalars['Boolean']>;
  creditCardOption?: Maybe<Scalars['Boolean']>;
  appliedBy?: Maybe<Scalars['String']>;
  /** PaymentDate */
  paymentDate?: Maybe<Scalars['DateTime']>;
  /** maxPaymentDate */
  maxPaymentDate?: Maybe<Scalars['DateTime']>;
  office?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  paymentAgreementLink?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  salary?: Maybe<Scalars['String']>;
  monthlyPayments?: Maybe<Scalars['String']>;
  extraIncomeEconomic?: Maybe<Scalars['String']>;
  extraIncome?: Maybe<Scalars['String']>;
};

export type NegotiationOption = {
  __typename?: 'NegotiationOption';
  /** type enum */
  type: NegotiationType;
  /** alternatives list */
  alternatives: Array<NegotiationOptionAlternative>;
  /** is this negotiation option available? */
  available: Scalars['Boolean'];
  /** extra info for why is this option not available or other important info for the user */
  hint?: Maybe<Scalars['String']>;
  availableGracePeriods: Array<Scalars['Int']>;
  /** should auto continue / redirect to next step (PaymentPromise and NoOptions) */
  autoContinue: Scalars['Boolean'];
  /** requirements for acceptance of option ( cuando es mayor a 14M debe llenar una información extra ) */
  extraConfirmationInfo?: Maybe<NegotiationOptionExtraConfirmationInfoType>;
  /** own rate of negotiation option */
  rate?: Maybe<Scalars['Float']>;
  /** this field is related with ACPK Davivienda alternative */
  validUntil?: Maybe<Scalars['DateTime']>;
  /** is this option pre-calculated by the bank, or calculated by us */
  isPreCalculated?: Maybe<Scalars['Boolean']>;
  /** settings for the frontend */
  settings?: Maybe<NegotiationOptionSettings>;
};

export type NegotiationOptionAlternative = {
  __typename?: 'NegotiationOptionAlternative';
  /** term of alternative (total months to pay) */
  term: Scalars['Float'];
  /** value (monthly amount to pay) */
  value: Scalars['Float'];
  /** currency type for this alternative */
  currency: Currency;
  /** grace period (months without pay) */
  gracePeriod?: Maybe<Scalars['Float']>;
  /** is this alternative available? */
  available: Scalars['Boolean'];
  /** extra info for why is it not available or other important info for the user */
  hint?: Maybe<Scalars['String']>;
  /** discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  discountValue?: Maybe<Scalars['Float']>;
  /** discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  discountPercent?: Maybe<Scalars['Float']>;
  /** Real discount percent over the minimumPayment or monthlyPayment. It is saved in Database */
  realDiscountValue?: Maybe<Scalars['Float']>;
  /** discount percent over the minimumPayment or monthlyPayment, pre-calculated so the front only shows it */
  realDiscountPercent?: Maybe<Scalars['Float']>;
  /** for some negotiation options (cancelación total) the total balance has a discount depending on the alternative */
  balance?: Maybe<Scalars['Float']>;
  /** some negotiations need some pre payment from the user (Abono mínimo para poder efectuar negociación) */
  prePayment?: Maybe<Scalars['Float']>;
  /** BBVA: valor del extracupo cuando aplica (snapshot del último assignment), pre-calculated so the front only shows it */
  extracupo?: Maybe<Scalars['Float']>;
  /** BBVA: pago inicial total (prePayment + extracupo) cuando aplica, pre-calculated so the front only shows it */
  totalInitialPayment?: Maybe<Scalars['Float']>;
  /** should this alternative be hidden (initially) */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Type of alternative regarding how much balance is covered. */
  type?: Maybe<NegotiationOptionAlternativeType>;
  /** Commission percent applied to alternative value. */
  commissionPercent?: Maybe<Scalars['Float']>;
  /** Commission value applied to alternative value. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** Monthly interest rate i = (1+EA)^(1/12) - 1 */
  interestsRate?: Maybe<Scalars['Float']>;
  /** Effective annual rate EA used to compute installments */
  effectiveAnnualRate?: Maybe<Scalars['Float']>;
  /** Discount fraction applied to mora interests INTERES_MORA (0–1) */
  discountMora?: Maybe<Scalars['Float']>;
  /** Total amount to pay for this alternative */
  totalAmountToPay?: Maybe<Scalars['Float']>;
  /** Custom negotiation created by an admin */
  isCustomNegotiation?: Maybe<Scalars['Boolean']>;
  /** Special campaign alternative created by an admin */
  isSpecialCampaign?: Maybe<Scalars['Boolean']>;
};

/** NegotiationOptionAlternativeType name */
export enum NegotiationOptionAlternativeType {
  MinPayment = 'MIN_PAYMENT',
  BalanceBehind = 'BALANCE_BEHIND',
  Behind_30 = 'BEHIND_30',
  Behind_60 = 'BEHIND_60',
  Behind_90 = 'BEHIND_90',
  Behind_120 = 'BEHIND_120',
  Traditional = 'TRADITIONAL',
  LowRate = 'LOW_RATE',
  NoPayment = 'NO_PAYMENT',
  SpecialCampaignLowRate = 'SPECIAL_CAMPAIGN_LOW_RATE',
  DiscountInterest = 'DISCOUNT_INTEREST',
  DiscountInterestLowRate = 'DISCOUNT_INTEREST_LOW_RATE',
  Condonation = 'CONDONATION',
  SpecialCampaign = 'SPECIAL_CAMPAIGN',
  PrepaymentWeightedRate = 'PREPAYMENT_WEIGHTED_RATE',
  NoPrepaymentWeightedRate = 'NO_PREPAYMENT_WEIGHTED_RATE',
  NoPrepaymentPreferentialRate = 'NO_PREPAYMENT_PREFERENTIAL_RATE',
  PrepaymentPreferentialRate = 'PREPAYMENT_PREFERENTIAL_RATE',
  Modification = 'MODIFICATION',
  Restructuring = 'RESTRUCTURING',
  Refinance = 'REFINANCE',
  ExternalNegotiation = 'EXTERNAL_NEGOTIATION',
  WithDiscount = 'WITH_DISCOUNT',
  WithoutDiscount = 'WITHOUT_DISCOUNT'
}

/** NegotiationOptionExtraConfirmationInfoType name */
export enum NegotiationOptionExtraConfirmationInfoType {
  NoExtraInfo = 'NoExtraInfo',
  CityAndOffice = 'CityAndOffice',
  NewPaymentDate = 'NewPaymentDate',
  NonPaymentReason = 'NonPaymentReason',
  NonPaymentReasonCancellationNewPaymentDay = 'NonPaymentReasonCancellationNewPaymentDay',
  NonPaymentReasonPaymentDate = 'NonPaymentReasonPaymentDate',
  NonPaymentReasonPaymentAndDateWithAgreement = 'NonPaymentReasonPaymentAndDateWithAgreement',
  UserConfirmation = 'UserConfirmation',
  EconomicActivity = 'EconomicActivity',
  PrePaymentDateAndInstallmentDay = 'PrePaymentDateAndInstallmentDay'
}

export type NegotiationOptionSettings = {
  __typename?: 'NegotiationOptionSettings';
  /** minimum value for user defined prePayment */
  min?: Maybe<Scalars['Float']>;
  /** maximum value for user defined prePayment */
  max?: Maybe<Scalars['Float']>;
  /** step for user defined prePayment input */
  step?: Maybe<Scalars['Float']>;
  /** is the prePayment input available? */
  withPrePaymentInput?: Maybe<Scalars['Boolean']>;
  /** max payment date for new negotiation pre payment */
  maxPaymentDate?: Maybe<Scalars['DateTime']>;
  /** id of parent debt to search for the same negotiation type, in case of a virtual debt */
  parentOptionDebt?: Maybe<Scalars['String']>;
  /** Is this child option only a shortcut to the parent option, or should it be a valid option in itself? */
  isShortcutToParent?: Maybe<Scalars['Boolean']>;
  /** Virtual outDebt will be the only debt managed (do not show or operate children debts) */
  virtualDebtOnly?: Maybe<Scalars['Boolean']>;
  /** Whether term extension requires document signing (BdB only) */
  isDocumentalTermExtension?: Maybe<Scalars['Boolean']>;
};

/** State of Negotiation */
export enum NegotiationState {
  ConfirmedByUser = 'CONFIRMED_BY_USER',
  PrepaymentCompleted = 'PREPAYMENT_COMPLETED',
  PaymentInProgress = 'PAYMENT_IN_PROGRESS',
  PrepaymentIncomplete = 'PREPAYMENT_INCOMPLETE',
  SentToBank = 'SENT_TO_BANK',
  ApprovedByBank = 'APPROVED_BY_BANK',
  RejectedByBank = 'REJECTED_BY_BANK',
  Expired = 'EXPIRED'
}

/** NegotiationType name */
export enum NegotiationType {
  Refinance = 'Refinance',
  ExpressRefinance = 'ExpressRefinance',
  Normalization = 'Normalization',
  CatchUp = 'CatchUp',
  Restructure = 'Restructure',
  InstallmentsPlan = 'InstallmentsPlan',
  Condonation = 'Condonation',
  Modification = 'Modification',
  Quotification = 'Quotification',
  ConditionsRedefinition = 'ConditionsRedefinition',
  TotalPayment = 'TotalPayment',
  PenaltyPortfolioPaymentAgreement = 'PenaltyPortfolioPaymentAgreement',
  PaymentPromise = 'PaymentPromise',
  BalanceBehindPayment = 'BalanceBehindPayment',
  TermExtension = 'TermExtension',
  NoOptions = 'NoOptions'
}

/** Days behind exposition (Exposición de Mora) */
export enum Normative026 {
  Modification = 'MODIFICATION',
  Restructuring = 'RESTRUCTURING',
  Refinance = 'REFINANCE',
  Negotiation = 'NEGOTIATION'
}

export type OneTimeLink = {
  __typename?: 'OneTimeLink';
  id: Scalars['ID'];
  expirationDate: Scalars['DateTime'];
  payload: OneTimeLinkPayload;
};

export type OneTimeLinkPayload = {
  __typename?: 'OneTimeLinkPayload';
  brand: BrandType;
  country: Country;
  bank: BankType;
  redirectTo?: Maybe<Scalars['String']>;
};

export type OutDebt = {
  __typename?: 'OutDebt';
  id: Scalars['ID'];
  /** product number */
  productNumber?: Maybe<Scalars['String']>;
  /** tasa de interés */
  rate?: Maybe<Scalars['Float']>;
  /** Total balance */
  balance?: Maybe<Scalars['Float']>;
  /** principal balance */
  balancePrincipal?: Maybe<Scalars['Float']>;
  /** daysBehind */
  daysBehind?: Maybe<Scalars['Float']>;
  /** exm */
  exm?: Maybe<ExmType>;
  /** debt type CREDIT_CARD, ALL_PURPOSE, etc */
  type: DebtType;
  /** product subtype for tc is Visa, Mastercard, Diners */
  subType?: Maybe<Scalars['String']>;
  /** paymentDate */
  paymentDate?: Maybe<Scalars['DateTime']>;
  minPayment?: Maybe<Scalars['Float']>;
  /** monthlyPayment */
  monthlyPayment?: Maybe<Scalars['Float']>;
  balanceBehind?: Maybe<Scalars['Float']>;
  /** Extra info */
  extra?: Maybe<OutDebtExtra>;
  /** pre calculated NegotiationOptions list, given by the bank */
  preCalcNegotiationOptionsBank?: Maybe<Array<NegotiationOption>>;
  /** bank/creditor */
  bank: BankType;
  /** brand */
  brand?: Maybe<BrandType>;
  /** country */
  country?: Maybe<Country>;
  debtManager: DebtManager;
  /** Compound key by type(OutDebt), document(Client) and productNumber(OutDebt) */
  compId?: Maybe<Scalars['String']>;
  /** payment list */
  payments?: Maybe<Array<Payment>>;
  /** filled if out debts has been negotiated */
  negotiation?: Maybe<Negotiation>;
};

export type OutDebtExtra = {
  __typename?: 'OutDebtExtra';
  /** Circular 026 (null, Reestructuración, Modificación) */
  normative026?: Maybe<Normative026>;
  /** Deprecated, keep to prevent errors in front */
  C026?: Maybe<Scalars['String']>;
  /** País */
  country?: Maybe<Scalars['String']>;
  /** Indica si el archivo procesado es de una asignación o de un evolutivo. Los valores posibles son True o False */
  is_assignment?: Maybe<Scalars['Boolean']>;
  /** Día de facturación, día en que se genera la factura */
  billingDay?: Maybe<Scalars['Float']>;
  /** Fecha de vencimiento de la deuda */
  expirationDate?: Maybe<Scalars['DateTime']>;
  /** Fecha de castigo de la deuda */
  punishDate?: Maybe<Scalars['DateTime']>;
  /** Intereses corrientes sobre el saldo de la obligación */
  currentInterests?: Maybe<Scalars['Float']>;
  /** Capital de mora */
  balancePrincipalBehind?: Maybe<Scalars['Float']>;
  /** Capital no exigible */
  balancePrincipalNonDue?: Maybe<Scalars['Float']>;
  /** Intereses sobre la mora de la obligación */
  defaultInterests?: Maybe<Scalars['Float']>;
  /** Valor del seguro */
  insuranceValue?: Maybe<Scalars['Float']>;
  /** Calificación de Obligación */
  score?: Maybe<Scalars['String']>;
  /** Otros Vlr FNG y otros conceptos */
  otherCharges?: Maybe<Scalars['Float']>;
  /** Otros cargos no exigibles */
  otherChargesNonDue?: Maybe<Scalars['Float']>;
  /** Cuotas en mora */
  installmentsBehind?: Maybe<Scalars['Float']>;
  /**
   * Vector actual donde cada número simboliza las cuotas de mora que tiene
   *   el usuari. Ej: 2345. Esto quiere decir que en el mes actual tiene con 2 cuotas de mora, en el mes anterior contaba con 3
   *   cuotas de mora y así sucesivamente
   */
  currentVector?: Maybe<Array<Scalars['Int']>>;
  /** Plazo inicial de la deuda */
  originalTerm?: Maybe<Scalars['Float']>;
  /** Saldo inicial de la deuda (balance), cambia cada mes */
  initialBalance?: Maybe<Scalars['Float']>;
  /** SALDO_ACTUAL_OBLIG — saldo total de la obligación sin otros cargos */
  originalBalance?: Maybe<Scalars['Float']>;
  /** Mora inicial de la deuda (balance), cambia cada mes */
  initialBalanceBehind?: Maybe<Scalars['Float']>;
  /** Días de mora inicial de la deuda, cambia cada mes */
  initialDaysBehind?: Maybe<Scalars['Float']>;
  /** exm */
  initialExm?: Maybe<ExmType>;
  /** last assignment of client */
  lastAssignment?: Maybe<Scalars['String']>;
  /** histocial assignment */
  historicalAssignment?: Maybe<Array<Scalars['String']>>;
  /** Fecha de desembolso de la deuda */
  disbursementDate?: Maybe<Scalars['DateTime']>;
  /** Fecha de corte mensual */
  cutoffDate?: Maybe<Scalars['DateTime']>;
  /** children out debts for unification */
  children?: Maybe<Array<OutDebt>>;
  /** Debt is included in the current uncollectible snapshot */
  uncollectible?: Maybe<Scalars['Boolean']>;
  state?: Maybe<OutDebtState>;
  daviplata?: Maybe<Scalars['Boolean']>;
  product?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
  /** Commerce in which this credit was issued */
  commerce?: Maybe<Scalars['String']>;
  paymentLinkTotalPayment?: Maybe<Scalars['String']>;
  /** Referencia de pago del usuario */
  paymentReference?: Maybe<Scalars['String']>;
  movistarInvoice?: Maybe<Scalars['String']>;
  /** Alternativa de normalización sin transformar */
  normative026Raw?: Maybe<Scalars['String']>;
  /** Plazo RFMC, plazo máximo que se le puede ofrecer a un cliente */
  maxTerm?: Maybe<Scalars['Float']>;
  commissionPercent?: Maybe<Scalars['Float']>;
  commissionValue?: Maybe<Scalars['Float']>;
  isFallen?: Maybe<Scalars['Boolean']>;
  isCededed?: Maybe<Scalars['Boolean']>;
  headProductNumber?: Maybe<Scalars['String']>;
  popup?: Maybe<Scalars['String']>;
  macroportDescription?: Maybe<Scalars['String']>;
  popupRate?: Maybe<Scalars['Float']>;
  extraAccountingInterests?: Maybe<Scalars['Float']>;
  condonationFlag?: Maybe<Scalars['String']>;
  popupRaw?: Maybe<Scalars['String']>;
  issuingEntity?: Maybe<Scalars['String']>;
  portfolio?: Maybe<Scalars['String']>;
  /** Indica si el producto pertenece a la campaña C25 */
  isC25?: Maybe<Scalars['Boolean']>;
  /** Tipo de bloqueo del producto */
  blockType?: Maybe<BlockType>;
  /** Ingresos del usuario */
  userIncome?: Maybe<Scalars['Float']>;
  /** Portfolio purchase (origin bank) for APEX punished debts -  "Compra Cartera" */
  portfolioPurchase?: Maybe<Scalars['String']>;
  /** Stage for APEX punished debts - "Etapa" */
  stage?: Maybe<Scalars['String']>;
  /** Harvest/vintage for APEX punished debts - "Cosechas" */
  cosechas?: Maybe<Scalars['String']>;
  /** Debt status for APEX punished debts */
  debtStatus?: Maybe<Scalars['String']>;
  /** Type label for APEX punished debts */
  typeLabel?: Maybe<Scalars['String']>;
  /** Main bank for the virtual debt, determined by the debt with the highest balance - APEX */
  mainBank?: Maybe<Scalars['String']>;
  /** Device Reference in the Flexicuota Debt */
  flexiCuotaModel?: Maybe<Scalars['String']>;
  /** Status of the Flexicuota Debt */
  flexiCuotaStatus?: Maybe<Scalars['String']>;
  /** Agency of the Flexicuota Debt */
  flexiCuotaAgency?: Maybe<Scalars['String']>;
  /** First installment of the Flexicuota Debt */
  flexiCuotaFirstInstallment?: Maybe<Scalars['Float']>;
  /** Indicates if the debt is a Flexicuota debt */
  isFlexiCuota?: Maybe<Scalars['Boolean']>;
  /** Status of previous agreement (CERRADO_MANUALMENTE, VIGENTE, INCUMPLIDO, etc.) - Field: ESTADO */
  previousAgreementStatus?: Maybe<Scalars['String']>;
  /** Creation date of previous agreement - Field: FECHA_CREACION_ACUERDO */
  previousAgreementDate?: Maybe<Scalars['DateTime']>;
  /** Type of previous agreement (Negociacion, Condonacion) - Field: TIPO */
  previousAgreementType?: Maybe<Scalars['String']>;
  /** Discount percent for 2-6 installments - Field: "2-6 cuotas" */
  discountPercent2to6?: Maybe<Scalars['Float']>;
  /** Discount percent for 7-12 installments - Field: "7-12 cuotas" */
  discountPercent7to12?: Maybe<Scalars['Float']>;
  /** Discount percent for >12 installments - Field: "> 12 meses" */
  discountPercentOver12?: Maybe<Scalars['Float']>;
  /** Assignment date - Field: FECHA_DE_ASIGNACION Claro */
  assignmentDate?: Maybe<Scalars['DateTime']>;
  /** Final date - Field: Fecha Final Claro: Fecha máxima hasta la cual se pueden gestionar los usuarios  */
  finalDate?: Maybe<Scalars['DateTime']>;
  /** Indicates if the product belongs to the Potencial Mark campaign */
  potencialMark?: Maybe<Scalars['Boolean']>;
  /** Indicates if the product belongs to the Pre Potencial Mark campaign */
  prePotencialMark?: Maybe<Scalars['Boolean']>;
  /** Indicates if the product belongs to the Write Off Mark campaign */
  writeOffMark?: Maybe<Scalars['Boolean']>;
  /** Segmentation state for Claro debts (PREPOTENCIAL, POTENCIAL, PRECHURN, CHURN, PREPROVISION, PROVISION, CASTIGO) */
  segmentationState?: Maybe<Scalars['String']>;
  /** Reference Code */
  customerTypeId?: Maybe<Scalars['String']>;
  /** Calificación de Obligación */
  scoring?: Maybe<Scalars['Float']>;
  /** CLARO assignment discount campaigns matching crmOrigen + customerTypeId */
  campaigns?: Maybe<Array<ClaroCampaign>>;
  /** Plan - Field: Plan Claro */
  claroPlan?: Maybe<Scalars['String']>;
  /** Agreed installments - Field: Cuotas Pactadas Claro */
  agreedInstallments?: Maybe<Scalars['Float']>;
  /** Billed installments - Field: Cuotas Facturadas Claro */
  billedInstallments?: Maybe<Scalars['Float']>;
  /** Pending installments - Field: Cuotas Pendientes Claro */
  pendingInstallments?: Maybe<Scalars['Float']>;
  /** Activation date (raw) - Field: Fecha Digitación/Activación Claro */
  activationDate?: Maybe<Scalars['String']>;
  /** Indicates if the product belongs to a special campaign */
  isSpecialCampaign?: Maybe<Scalars['Boolean']>;
  /** SALDO_METAS */
  officialBalance?: Maybe<Scalars['Float']>;
  /** PRIMA_UNICA */
  oneTimePremium?: Maybe<Scalars['Float']>;
  /** TIEMPO_ENTRE_MECANISMOS */
  timeBetweenMechanisms?: Maybe<Scalars['String']>;
  /** OTROS_CARGOS_EXIGIBLES: Other exigible charges (Banco de Bogotá CMD) */
  otherExigibleCharges?: Maybe<Scalars['Float']>;
};

/** Out debt state types */
export enum OutDebtState {
  Punished = 'PUNISHED',
  Valid = 'VALID'
}

export type OutDebtsReport = {
  __typename?: 'OutDebtsReport';
  /** Has at least one currently assigned out debt */
  hasSome: Scalars['Boolean'];
  /** Banks to which the assigned out debts belong */
  managedBanks: Array<ManagedBank>;
  /** Should this user be auto-redirected to negotiator app? */
  shouldRedirectToNegotiator: Scalars['Boolean'];
};

export type Payment = {
  __typename?: 'Payment';
  /** Fecha de pago YYYY-MM-DD */
  date: Scalars['DateTime'];
  /** VALOR_PAGO */
  value: Scalars['Float'];
  /** CANAL */
  channel?: Maybe<Scalars['String']>;
  /** DESCRIPCION_DEL_PAGO */
  description?: Maybe<Scalars['String']>;
  /** VALOR_EN_CHEQUE */
  checkValue?: Maybe<Scalars['Float']>;
  /** FECHA_DE_APLICACION */
  applicationDate?: Maybe<Scalars['DateTime']>;
  /** ID_PAGO */
  paymentId?: Maybe<Scalars['String']>;
  /** ESTADO_PAGO */
  paymentStatus?: Maybe<Scalars['String']>;
  /** APLICADO_A */
  appliedTo?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  id: Scalars['ID'];
  /** Related User */
  user: User;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  /** Cédula */
  document?: Maybe<Scalars['String']>;
  /** Timestamp to probe terms and conditions authorization */
  authorization?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  outDebtNegotiationOptions: Array<NegotiationOption>;
  getOneTimeLink: OneTimeLink;
  profile?: Maybe<Profile>;
  setting: SettingValue;
  getRegisterdPhoneLastDigits: Array<Scalars['String']>;
  identityConfirmationOptions: Array<IdentityConfirmationOption>;
  outDebts: Array<OutDebt>;
  outDebtsReport: OutDebtsReport;
  /**
   * Return whole productNumberDef, if outDebt is PUNISHED and user is
   *   confirmed. If It doesn't have productNumberDef, return productNumber field. If it is not
   *   PUNISHED or user is not confirmed, return empty string. Otherwise, If outDebt doesn't belong
   *   to the user or client, this method throw an error
   */
  getProductNumberDef: Scalars['String'];
};


export type QueryOutDebtNegotiationOptionsArgs = {
  declaredPaymentCapacity?: Maybe<Scalars['Float']>;
  declaredIncome?: Maybe<Scalars['Float']>;
  prePayment?: Maybe<Scalars['Float']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};


export type QueryGetOneTimeLinkArgs = {
  id: Scalars['String'];
};


export type QuerySettingArgs = {
  name: Scalars['String'];
};


export type QueryIdentityConfirmationOptionsArgs = {
  bank: Scalars['String'];
  brand: Scalars['String'];
};


export type QueryGetProductNumberDefArgs = {
  outDebtId: Scalars['String'];
};

/** Valid Settings name types */
export enum SettingNameType {
  ValidFrontVersion = 'VALID_FRONT_VERSION',
  EtlDefaults = 'ETL_DEFAULTS',
  FinalAssignmentDate = 'FINAL_ASSIGNMENT_DATE',
  DaysToPay = 'DAYS_TO_PAY',
  LatestClientVersion = 'LATEST_CLIENT_VERSION',
  WhatsappIdverSettings = 'WHATSAPP_IDVER_SETTINGS',
  Links = 'LINKS',
  ProcessesDate = 'PROCESSES_DATE',
  ApiSecretKey = 'API_SECRET_KEY',
  SettingsEventsToAnalytics = 'SETTINGS_EVENTS_TO_ANALYTICS',
  PaymentCloseRange = 'PAYMENT_CLOSE_RANGE',
  FeatureFlags = 'FEATURE_FLAGS',
  LegalAcceptanceVersion = 'LEGAL_ACCEPTANCE_VERSION',
  BrandSettings = 'BRAND_SETTINGS',
  LastSettingsImportDate = 'LAST_SETTINGS_IMPORT_DATE',
  CommissionPercentsByDaysBehind = 'COMMISSION_PERCENTS_BY_DAYS_BEHIND',
  DavPaymentPromiseSettings = 'DAV_PAYMENT_PROMISE_SETTINGS',
  DavPartialPaymentPromiseSettings = 'DAV_PARTIAL_PAYMENT_PROMISE_SETTINGS',
  DavPaymentAgreementSettings = 'DAV_PAYMENT_AGREEMENT_SETTINGS',
  DavTotalPaymentSettings = 'DAV_TOTAL_PAYMENT_SETTINGS',
  DavNormalizationSettings = 'DAV_NORMALIZATION_SETTINGS',
  DavRefinanceSettings = 'DAV_REFINANCE_SETTINGS',
  DavRestructureSettings = 'DAV_RESTRUCTURE_SETTINGS',
  DavInstallmentsPlanSettings = 'DAV_INSTALLMENTS_PLAN_SETTINGS',
  DavC026FileArrivalDate = 'DAV_C026_FILE_ARRIVAL_DATE',
  BbvaPaymentPromiseSettings = 'BBVA_PAYMENT_PROMISE_SETTINGS',
  BbvaRefinanceSettings = 'BBVA_REFINANCE_SETTINGS',
  BbvaTotalPaymentSettings = 'BBVA_TOTAL_PAYMENT_SETTINGS',
  BbvaInstallmentsPlanSettings = 'BBVA_INSTALLMENTS_PLAN_SETTINGS',
  BbvaFalloffNegotiationBlock = 'BBVA_FALLOFF_NEGOTIATION_BLOCK',
  PichinchaRefinanceSettings = 'PICHINCHA_REFINANCE_SETTINGS',
  PichinchaExpressRefinanceSettings = 'PICHINCHA_EXPRESS_REFINANCE_SETTINGS',
  PichinchaTotalPaymentSettings = 'PICHINCHA_TOTAL_PAYMENT_SETTINGS',
  PichinchaPaymentPromiseSettings = 'PICHINCHA_PAYMENT_PROMISE_SETTINGS',
  RappipayTotalPaymentSettings = 'RAPPIPAY_TOTAL_PAYMENT_SETTINGS',
  RappipayRefinanceSettings = 'RAPPIPAY_REFINANCE_SETTINGS',
  RappipayRestructureSettings = 'RAPPIPAY_RESTRUCTURE_SETTINGS',
  RappipayCondonationSettings = 'RAPPIPAY_CONDONATION_SETTINGS',
  RappipayPaymentPromiseSettings = 'RAPPIPAY_PAYMENT_PROMISE_SETTINGS',
  RappipayInstallmentsPlanSettings = 'RAPPIPAY_INSTALLMENTS_PLAN_SETTINGS',
  RappipayQuotificationSettings = 'RAPPIPAY_QUOTIFICATION_SETTINGS',
  RappipayGlobalCutoffDates = 'RAPPIPAY_GLOBAL_CUTOFF_DATES',
  RappipaySubproductTermLimits = 'RAPPIPAY_SUBPRODUCT_TERM_LIMITS',
  RappiPrestamoPaymentPromiseSettings = 'RAPPI_PRESTAMO_PAYMENT_PROMISE_SETTINGS',
  RappiPrestamoQuotificationSettings = 'RAPPI_PRESTAMO_QUOTIFICATION_SETTINGS',
  RappiPrestamoRefinanceSettings = 'RAPPI_PRESTAMO_REFINANCE_SETTINGS',
  RappiPrestamoRestructureSettings = 'RAPPI_PRESTAMO_RESTRUCTURE_SETTINGS',
  MovistarMoneyTotalPaymentSettings = 'MOVISTAR_MONEY_TOTAL_PAYMENT_SETTINGS',
  MovistarMoneyPaymentAgreementSettings = 'MOVISTAR_MONEY_PAYMENT_AGREEMENT_SETTINGS',
  MovistarMoneyPaymentPromiseSettings = 'MOVISTAR_MONEY_PAYMENT_PROMISE_SETTINGS',
  MovistarMoneyCatchUpSettings = 'MOVISTAR_MONEY_CATCH_UP_SETTINGS',
  BancoDeBogotaCommissionPercent = 'BANCO_DE_BOGOTA_COMMISSION_PERCENT',
  BancoDeBogotaTranqui90CommissionPercent = 'BANCO_DE_BOGOTA_TRANQUI90_COMMISSION_PERCENT',
  BancoDeBogotaPaymentPromiseSettings = 'BANCO_DE_BOGOTA_PAYMENT_PROMISE_SETTINGS',
  BancoDeBogotaTotalPaymentSettings = 'BANCO_DE_BOGOTA_TOTAL_PAYMENT_SETTINGS',
  BancoDeBogotaRefinanceSettings = 'BANCO_DE_BOGOTA_REFINANCE_SETTINGS',
  BancoDeBogotaInstallmentsPlanSettings = 'BANCO_DE_BOGOTA_INSTALLMENTS_PLAN_SETTINGS',
  BancoDeBogotaBalanceBehindPaymentSettings = 'BANCO_DE_BOGOTA_BALANCE_BEHIND_PAYMENT_SETTINGS',
  BancoDeBogotaTermExtensionSettings = 'BANCO_DE_BOGOTA_TERM_EXTENSION_SETTINGS',
  BancoDeBogotaProductCutoffDates = 'BANCO_DE_BOGOTA_PRODUCT_CUTOFF_DATES',
  ScotiabankDaysBehind = 'SCOTIABANK_DAYS_BEHIND',
  ScotiabankPaymentPromiseSettings = 'SCOTIABANK_PAYMENT_PROMISE_SETTINGS',
  ScotiabankRefinanceSettings = 'SCOTIABANK_REFINANCE_SETTINGS',
  ScotiabankFileBuildSettings = 'SCOTIABANK_FILE_BUILD_SETTINGS',
  BetaTotalPaymentSettings = 'BETA_TOTAL_PAYMENT_SETTINGS',
  BetaPaymentAgreementSettings = 'BETA_PAYMENT_AGREEMENT_SETTINGS',
  BetaPaymentPromiseSettings = 'BETA_PAYMENT_PROMISE_SETTINGS',
  JcapTotalPaymentSettings = 'JCAP_TOTAL_PAYMENT_SETTINGS',
  JcapPaymentAgreementSettings = 'JCAP_PAYMENT_AGREEMENT_SETTINGS',
  PraTotalPaymentSettings = 'PRA_TOTAL_PAYMENT_SETTINGS',
  PraPaymentAgreementSettings = 'PRA_PAYMENT_AGREEMENT_SETTINGS',
  ApexTotalPaymentSettings = 'APEX_TOTAL_PAYMENT_SETTINGS',
  ApexPaymentAgreementSettings = 'APEX_PAYMENT_AGREEMENT_SETTINGS',
  ClaroPaymentPromiseSettings = 'CLARO_PAYMENT_PROMISE_SETTINGS',
  ClaroAssignmentDiscountCampaign = 'CLARO_ASSIGNMENT_DISCOUNT_CAMPAIGN',
  ClaroDiscountCampaign = 'CLARO_DISCOUNT_CAMPAIGN',
  LuloPaymentPromiseSettings = 'LULO_PAYMENT_PROMISE_SETTINGS',
  LuloRefinanceSettings = 'LULO_REFINANCE_SETTINGS',
  LuloModificationSettings = 'LULO_MODIFICATION_SETTINGS',
  LuloRestructureSettings = 'LULO_RESTRUCTURE_SETTINGS',
  WompiVars = 'WOMPI_VARS',
  PipelineRewritePayments = 'PIPELINE_REWRITE_PAYMENTS',
  PipelinesNotificationInterval = 'PIPELINES_NOTIFICATION_INTERVAL',
  PipelinesSkipDemographicsBuild = 'PIPELINES_SKIP_DEMOGRAPHICS_BUILD',
  FileBuildSettings = 'FILE_BUILD_SETTINGS',
  AgentManagementFormOptions = 'AGENT_MANAGEMENT_FORM_OPTIONS',
  DataLakeS3UploadOptions = 'DATA_LAKE_S3_UPLOAD_OPTIONS',
  MovistarMoneyPaymentsSettings = 'MOVISTAR_MONEY_PAYMENTS_SETTINGS',
  PaymentDateSettings = 'PAYMENT_DATE_SETTINGS',
  DealMakerBankOptions = 'DEAL_MAKER_BANK_OPTIONS',
  DealMakerOtpOptions = 'DEAL_MAKER_OTP_OPTIONS',
  DealMakerTransUnionEnabled = 'DEAL_MAKER_TRANS_UNION_ENABLED',
  DealMakerBrandCountryBankRedirectEntity = 'DEAL_MAKER_BRAND_COUNTRY_BANK_REDIRECT_ENTITY',
  MetaIntegrationSettings = 'META_INTEGRATION_SETTINGS',
  ContactInfoAssignmentThreshold = 'CONTACT_INFO_ASSIGNMENT_THRESHOLD',
  ClientContactInfoLabels = 'CLIENT_CONTACT_INFO_LABELS',
  OfferValidationSettings = 'OFFER_VALIDATION_SETTINGS',
  AgenticTypificationSettings = 'AGENTIC_TYPIFICATION_SETTINGS',
  GlobalSettingByEntity = 'GLOBAL_SETTING_BY_ENTITY',
  WolkvoxConfigByEntity = 'WOLKVOX_CONFIG_BY_ENTITY',
  AdminEmailDomains = 'ADMIN_EMAIL_DOMAINS'
}

export type SettingValue = {
  __typename?: 'SettingValue';
  /** Final Assigment Date */
  finalAssignmentDate?: Maybe<Array<FinalAssignmentDate>>;
  /** Current client build version. */
  v: Scalars['String'];
  /** Found client version error. */
  versionErrorType: VersionErrorType;
  /** Legal document versions */
  legalAcceptanceVersion?: Maybe<LegalAcceptanceVersion>;
  /** General info by entity */
  globalSettingByEntity?: Maybe<Array<GlobalSettingByEntity>>;
  appliedByType: AppliedByType;
  settingNameType: SettingNameType;
};

export type TwilioPhoneVerification = {
  __typename?: 'TwilioPhoneVerification';
  id: Scalars['ID'];
  /** Related User */
  user: User;
  /** Code sent to user phone number */
  code?: Maybe<Scalars['String']>;
  /** Phone number used for verification */
  phone: Scalars['String'];
  /** Twilio verification type: Whats App or SMS */
  type?: Maybe<TwilioPhoneVerificationType>;
  /** Current verification code state */
  state: TwilioPhoneVerificationState;
};

/** Valid TwilioPhoneVerification states */
export enum TwilioPhoneVerificationState {
  Sent = 'Sent',
  Expired = 'Expired',
  Canceled = 'Canceled',
  Verified = 'Verified'
}

/** Valid TwilioPhoneVerification Type */
export enum TwilioPhoneVerificationType {
  WhatsApp = 'WhatsApp',
  Sms = 'Sms'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** Cédula */
  document?: Maybe<Scalars['String']>;
  /** User settings */
  settings: UserSettings;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  /** Is the user registered without a real authentication method */
  simple?: Maybe<Scalars['Boolean']>;
  /** Has confirmed phone? Regardless of source of number (bank info or user provided) */
  phoneConfirmed?: Maybe<Scalars['Boolean']>;
  /** Has confirmed identity? Regardless of validation method */
  identityConfirmed?: Maybe<Scalars['Boolean']>;
  /** Has confirmed identity through whatsapp? Regardless of validation method */
  identityConfirmedByWhatsApp?: Maybe<Scalars['Boolean']>;
  /** Has confirmed identity through phone call? Regardless of validation method */
  identityConfirmedByPhoneCall?: Maybe<Scalars['Boolean']>;
  /** WhatsApp identity validation remaining tries. */
  remainingValidationTries?: Maybe<Scalars['Float']>;
  /** The identity/phone confirmation was done by this user id in the admin interface */
  identityConfirmedByAdmin?: Maybe<Scalars['Float']>;
  /** How many times has the user requested a simple auth? (like a SearchWithCC event) */
  simpleRequest?: Maybe<Scalars['Float']>;
  /** Associated client Id, if any */
  clientId?: Maybe<Scalars['ID']>;
  testUser?: Maybe<Scalars['Boolean']>;
  identityValidationBlock?: Maybe<IdentityValidationBlock>;
  legalVersion?: Maybe<LegalAcceptanceVersion>;
};

/** Valid client version error types */
export enum VersionErrorType {
  VersionMismatch = 'VERSION_MISMATCH',
  NoClientVersion = 'NO_CLIENT_VERSION'
}

export type AcceptLegalTermsMutationVariables = Exact<{
  termsAndConditions: Scalars['Boolean'];
  dataProcessing: Scalars['Boolean'];
}>;


export type AcceptLegalTermsMutation = (
  { __typename?: 'Mutation' }
  & { acceptLegalTerms?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
  )> }
);

export type ConfirmIdentityAdminMutationVariables = Exact<{
  bank: Scalars['String'];
  brand: Scalars['String'];
}>;


export type ConfirmIdentityAdminMutation = (
  { __typename?: 'Mutation' }
  & { confirmIdentityAdmin: (
    { __typename?: 'AuthUser' }
    & Pick<AuthUser, 'access'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export type ConfirmIdentityDeepLinkMutationVariables = Exact<{
  userId: Scalars['String'];
  token: Scalars['String'];
  bank: Scalars['String'];
}>;


export type ConfirmIdentityDeepLinkMutation = (
  { __typename?: 'Mutation' }
  & { confirmIdentityDeepLink: (
    { __typename?: 'AuthUser' }
    & Pick<AuthUser, 'access'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export type ConfirmIdentityEmailMutationVariables = Exact<{
  value: Scalars['String'];
  brand: Scalars['String'];
  bank: Scalars['String'];
  termsAndConditions: Scalars['Boolean'];
  dataProcessing: Scalars['Boolean'];
}>;


export type ConfirmIdentityEmailMutation = (
  { __typename?: 'Mutation' }
  & { confirmIdentityEmail: (
    { __typename?: 'AuthUser' }
    & Pick<AuthUser, 'access'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export type ConfirmIdentityOneTimeLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ConfirmIdentityOneTimeLinkMutation = (
  { __typename?: 'Mutation' }
  & { confirmIdentityOneTimeLink: (
    { __typename?: 'AuthUser' }
    & Pick<AuthUser, 'access'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export type CreateNegotiationMutationVariables = Exact<{
  outDebtId: Scalars['String'];
  bank: Scalars['String'];
  negotiationOption: InputNegotiationOption;
  negotiationType: Scalars['String'];
  alternative: InputNegotiationOptionAlternative;
  extraInfo: InputNegotiationExtraInfo;
}>;


export type CreateNegotiationMutation = (
  { __typename?: 'Mutation' }
  & { createNegotiation: (
    { __typename?: 'Negotiation' }
    & Pick<Negotiation, 'id' | 'type' | 'outDebtId' | 'bank' | 'state'>
  ) }
);

export type DeleteExpiredNegotiationMutationVariables = Exact<{
  negotiationId: Scalars['String'];
}>;


export type DeleteExpiredNegotiationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteExpiredNegotiation'>
);

export type GetOutDebtNegotiationOptionsQueryVariables = Exact<{
  debtId: Scalars['String'];
  gracePeriod?: Maybe<Scalars['Float']>;
  prePayment?: Maybe<Scalars['Float']>;
  declaredIncome?: Maybe<Scalars['Float']>;
  declaredPaymentCapacity?: Maybe<Scalars['Float']>;
}>;


export type GetOutDebtNegotiationOptionsQuery = (
  { __typename?: 'Query' }
  & { outDebtNegotiationOptions: Array<(
    { __typename?: 'NegotiationOption' }
    & Pick<NegotiationOption, 'type' | 'rate' | 'availableGracePeriods' | 'available' | 'autoContinue' | 'extraConfirmationInfo' | 'isPreCalculated'>
    & { alternatives: Array<(
      { __typename?: 'NegotiationOptionAlternative' }
      & Pick<NegotiationOptionAlternative, 'term' | 'value' | 'gracePeriod' | 'balance' | 'discountValue' | 'discountPercent' | 'realDiscountValue' | 'realDiscountPercent' | 'currency' | 'available' | 'prePayment' | 'hidden' | 'type' | 'commissionPercent' | 'commissionValue' | 'totalAmountToPay' | 'isSpecialCampaign' | 'isCustomNegotiation' | 'interestsRate' | 'effectiveAnnualRate' | 'discountMora' | 'extracupo' | 'totalInitialPayment'>
    )>, settings?: Maybe<(
      { __typename?: 'NegotiationOptionSettings' }
      & Pick<NegotiationOptionSettings, 'min' | 'max' | 'step' | 'maxPaymentDate' | 'parentOptionDebt' | 'isShortcutToParent' | 'isDocumentalTermExtension'>
    )> }
  )> }
);

export type GetIdentityConfirmationOptionsQueryVariables = Exact<{
  brand: Scalars['String'];
  bank: Scalars['String'];
}>;


export type GetIdentityConfirmationOptionsQuery = (
  { __typename?: 'Query' }
  & { identityConfirmationOptions: Array<(
    { __typename?: 'IdentityConfirmationOption' }
    & Pick<IdentityConfirmationOption, 'id' | 'type' | 'value' | 'values' | 'bank' | 'remainingAttempts' | 'attemptsExhausted'>
  )> }
);

export type GetOneTimeLinkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOneTimeLinkQuery = (
  { __typename?: 'Query' }
  & { getOneTimeLink: (
    { __typename?: 'OneTimeLink' }
    & { payload: (
      { __typename?: 'OneTimeLinkPayload' }
      & Pick<OneTimeLinkPayload, 'redirectTo' | 'brand' | 'country' | 'bank'>
    ) }
  ) }
);

export type GetOutDebtsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutDebtsQuery = (
  { __typename?: 'Query' }
  & { outDebts: Array<(
    { __typename?: 'OutDebt' }
    & OutDebtFieldsFragment
  )> }
);

export type GetProductNumberDefQueryVariables = Exact<{
  outDebtId: Scalars['String'];
}>;


export type GetProductNumberDefQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getProductNumberDef'>
);

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = (
  { __typename?: 'Query' }
  & { profile?: Maybe<(
    { __typename?: 'Profile' }
    & ProfileFieldsFragment
  )> }
);

export type GetSettingQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetSettingQuery = (
  { __typename?: 'Query' }
  & { setting: (
    { __typename?: 'SettingValue' }
    & { finalAssignmentDate?: Maybe<Array<(
      { __typename?: 'FinalAssignmentDate' }
      & Pick<FinalAssignmentDate, 'bank' | 'brand' | 'regularDate' | 'prePunishedDate' | 'description' | 'maxValidPaymentDate'>
    )>>, legalAcceptanceVersion?: Maybe<(
      { __typename?: 'LegalAcceptanceVersion' }
      & Pick<LegalAcceptanceVersion, 'termsAndConditions' | 'dataProcessingPolicy'>
    )>, globalSettingByEntity?: Maybe<Array<(
      { __typename?: 'GlobalSettingByEntity' }
      & { entitySelector: (
        { __typename?: 'EntitySelector' }
        & Pick<EntitySelector, 'brand' | 'bank' | 'country'>
      ), domainWhatsapp: (
        { __typename?: 'EntityWhatsappInfo' }
        & Pick<EntityWhatsappInfo, 'number' | 'formattedNumber'>
      ), domainCalls?: Maybe<(
        { __typename?: 'EntityCallInfo' }
        & Pick<EntityCallInfo, 'number' | 'formattedNumber'>
      )> }
    )>> }
  ) }
);

export type NewTwilioPhoneVerificationMutationVariables = Exact<{
  phone?: Maybe<Scalars['String']>;
  digits?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}>;


export type NewTwilioPhoneVerificationMutation = (
  { __typename?: 'Mutation' }
  & { newTwilioPhoneVerification: (
    { __typename?: 'TwilioPhoneVerification' }
    & Pick<TwilioPhoneVerification, 'state' | 'code' | 'type'>
  ) }
);

export type TwilioPhoneVerificationMutationVariables = Exact<{
  code: Scalars['String'];
  brand: Scalars['String'];
  bank: Scalars['String'];
  termsAndConditions: Scalars['Boolean'];
  dataProcessing: Scalars['Boolean'];
}>;


export type TwilioPhoneVerificationMutation = (
  { __typename?: 'Mutation' }
  & { twilioPhoneVerification: (
    { __typename?: 'AuthUser' }
    & Pick<AuthUser, 'access'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'phone'>
    ) }
  ) }
);

export type UnvalidateTwilioVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type UnvalidateTwilioVerificationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unvalidateTwilioVerification'>
);

export type OutDebtsReportQueryVariables = Exact<{ [key: string]: never; }>;


export type OutDebtsReportQuery = (
  { __typename?: 'Query' }
  & { outDebtsReport: (
    { __typename?: 'OutDebtsReport' }
    & Pick<OutDebtsReport, 'hasSome' | 'shouldRedirectToNegotiator'>
    & { managedBanks: Array<(
      { __typename?: 'ManagedBank' }
      & Pick<ManagedBank, 'brand' | 'debtManager' | 'bank'>
    )> }
  ) }
);

export type UpdateMaxPaymentDateExpiredNegotiationMutationVariables = Exact<{
  negotiationId: Scalars['String'];
  maxPaymentDate: Scalars['DateTime'];
}>;


export type UpdateMaxPaymentDateExpiredNegotiationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateMaxPaymentDateExpiredNegotiation'>
);

export type UpdatePhoneMutationVariables = Exact<{
  phone: Scalars['String'];
}>;


export type UpdatePhoneMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePhone'>
);

export type NewWaChatEventMutationVariables = Exact<{ [key: string]: never; }>;


export type NewWaChatEventMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'newWaChatEvent'>
);

export type OutDebtFieldsFragment = (
  { __typename?: 'OutDebt' }
  & Pick<OutDebt, 'id' | 'productNumber' | 'balance' | 'monthlyPayment' | 'daysBehind' | 'type' | 'minPayment' | 'balanceBehind' | 'balancePrincipal' | 'subType' | 'rate' | 'bank' | 'paymentDate' | 'brand' | 'country' | 'exm'>
  & { payments?: Maybe<Array<(
    { __typename?: 'Payment' }
    & Pick<Payment, 'date' | 'value'>
  )>>, negotiation?: Maybe<(
    { __typename?: 'Negotiation' }
    & Pick<Negotiation, 'id' | 'state' | 'type' | 'createdAt' | 'updatedAt'>
    & { extra: (
      { __typename?: 'NegotiationExtra' }
      & Pick<NegotiationExtra, 'sentDate' | 'virtualId' | 'payment'>
      & { info?: Maybe<(
        { __typename?: 'NegotiationExtraInfo' }
        & Pick<NegotiationExtraInfo, 'age' | 'economic' | 'economicOther' | 'newPaymentDay' | 'cancelCheckbox' | 'appliedBy' | 'paymentDate' | 'city' | 'office' | 'paymentAgreementLink' | 'maxPaymentDate'>
      )> }
    ), negotiationOption: (
      { __typename?: 'NegotiationOption' }
      & Pick<NegotiationOption, 'type' | 'available' | 'availableGracePeriods' | 'autoContinue' | 'rate'>
      & { alternatives: Array<(
        { __typename?: 'NegotiationOptionAlternative' }
        & Pick<NegotiationOptionAlternative, 'term' | 'value' | 'discountValue' | 'discountPercent' | 'balance' | 'prePayment' | 'currency' | 'available' | 'type' | 'commissionPercent' | 'totalAmountToPay' | 'isSpecialCampaign' | 'isCustomNegotiation' | 'interestsRate' | 'effectiveAnnualRate' | 'discountMora' | 'extracupo' | 'totalInitialPayment'>
      )>, settings?: Maybe<(
        { __typename?: 'NegotiationOptionSettings' }
        & Pick<NegotiationOptionSettings, 'maxPaymentDate' | 'parentOptionDebt' | 'isShortcutToParent' | 'isDocumentalTermExtension'>
      )> }
    ), alternative: (
      { __typename?: 'NegotiationOptionAlternative' }
      & Pick<NegotiationOptionAlternative, 'value' | 'term' | 'prePayment' | 'currency' | 'available' | 'discountValue' | 'type' | 'commissionPercent' | 'totalAmountToPay' | 'isSpecialCampaign' | 'isCustomNegotiation' | 'discountPercent' | 'discountMora' | 'interestsRate' | 'effectiveAnnualRate' | 'extracupo' | 'totalInitialPayment'>
    ) }
  )>, extra?: Maybe<(
    { __typename?: 'OutDebtExtra' }
    & Pick<OutDebtExtra, 'state' | 'normative026' | 'normative026Raw' | 'initialExm' | 'daviplata' | 'originalTerm' | 'product' | 'billingDay' | 'paymentLinkTotalPayment' | 'movistarInvoice' | 'disbursementDate' | 'installmentsBehind' | 'campaign' | 'commissionPercent' | 'commissionValue' | 'isFallen' | 'headProductNumber' | 'popup' | 'popupRate' | 'popupRaw' | 'maxTerm' | 'mainBank' | 'issuingEntity' | 'extraAccountingInterests' | 'currentInterests' | 'defaultInterests' | 'otherCharges' | 'otherChargesNonDue' | 'condonationFlag' | 'blockType' | 'isC25' | 'userIncome' | 'paymentReference' | 'isCededed' | 'portfolio' | 'portfolioPurchase' | 'potencialMark' | 'prePotencialMark' | 'writeOffMark'>
    & { children?: Maybe<Array<(
      { __typename?: 'OutDebt' }
      & Pick<OutDebt, 'id' | 'productNumber' | 'balance' | 'type'>
      & { extra?: Maybe<(
        { __typename?: 'OutDebtExtra' }
        & Pick<OutDebtExtra, 'issuingEntity' | 'extraAccountingInterests' | 'currentInterests' | 'defaultInterests' | 'otherCharges' | 'otherChargesNonDue'>
      )> }
    )>> }
  )> }
);

export type ProfileFieldsFragment = (
  { __typename?: 'Profile' }
  & Pick<Profile, 'id' | 'firstname' | 'lastname' | 'email' | 'phone' | 'document'>
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'phone'>
    & { settings: (
      { __typename?: 'UserSettings' }
      & Pick<UserSettings, 'simple'>
      & { legalVersion?: Maybe<(
        { __typename?: 'LegalAcceptanceVersion' }
        & Pick<LegalAcceptanceVersion, 'termsAndConditions' | 'dataProcessingPolicy'>
      )> }
    ) }
  ) }
);

export type ConfirmIdentityCcNumberMutationVariables = Exact<{
  digits: Scalars['String'];
  brand: Scalars['String'];
  bank: Scalars['String'];
  termsAndConditions: Scalars['Boolean'];
  dataProcessing: Scalars['Boolean'];
}>;


export type ConfirmIdentityCcNumberMutation = (
  { __typename?: 'Mutation' }
  & { confirmIdentityCCNumber: (
    { __typename?: 'AuthUser' }
    & Pick<AuthUser, 'access'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export const OutDebtFieldsFragmentDoc = gql`
    fragment outDebtFields on OutDebt {
  id
  productNumber
  balance
  monthlyPayment
  daysBehind
  type
  minPayment
  balanceBehind
  balancePrincipal
  subType
  rate
  bank
  paymentDate
  payments {
    date
    value
  }
  brand
  country
  exm
  negotiation {
    id
    state
    type
    createdAt
    updatedAt
    extra {
      sentDate
      virtualId
      payment
      info {
        age
        economic
        economicOther
        newPaymentDay
        cancelCheckbox
        appliedBy
        paymentDate
        city
        office
        paymentAgreementLink
        maxPaymentDate
      }
    }
    negotiationOption {
      type
      available
      availableGracePeriods
      autoContinue
      rate
      alternatives {
        term
        value
        discountValue
        discountPercent
        balance
        prePayment
        currency
        available
        type
        commissionPercent
        totalAmountToPay
        isSpecialCampaign
        isCustomNegotiation
        interestsRate
        effectiveAnnualRate
        discountMora
        extracupo
        totalInitialPayment
      }
      settings {
        maxPaymentDate
        parentOptionDebt
        isShortcutToParent
        isDocumentalTermExtension
      }
    }
    alternative {
      value
      term
      prePayment
      currency
      available
      discountValue
      type
      commissionPercent
      totalAmountToPay
      isSpecialCampaign
      isCustomNegotiation
      discountPercent
      discountMora
      interestsRate
      effectiveAnnualRate
      extracupo
      totalInitialPayment
    }
  }
  extra {
    state
    normative026
    normative026Raw
    initialExm
    daviplata
    originalTerm
    initialExm
    product
    billingDay
    paymentLinkTotalPayment
    movistarInvoice
    disbursementDate
    installmentsBehind
    campaign
    commissionPercent
    commissionValue
    isFallen
    headProductNumber
    popup
    popupRate
    popupRaw
    maxTerm
    mainBank
    issuingEntity
    extraAccountingInterests
    currentInterests
    defaultInterests
    otherCharges
    otherChargesNonDue
    condonationFlag
    blockType
    isC25
    userIncome
    paymentReference
    isCededed
    portfolio
    portfolioPurchase
    potencialMark
    prePotencialMark
    writeOffMark
    children {
      id
      productNumber
      balance
      type
      extra {
        issuingEntity
        extraAccountingInterests
        currentInterests
        defaultInterests
        otherCharges
        otherChargesNonDue
      }
    }
  }
}
    `;
export const ProfileFieldsFragmentDoc = gql`
    fragment profileFields on Profile {
  id
  firstname
  lastname
  email
  phone
  document
  user {
    id
    phone
    settings {
      simple
      legalVersion {
        termsAndConditions
        dataProcessingPolicy
      }
    }
  }
}
    `;
export const AcceptLegalTermsDocument = gql`
    mutation AcceptLegalTerms($termsAndConditions: Boolean!, $dataProcessing: Boolean!) {
  acceptLegalTerms(
    termsAndConditions: $termsAndConditions
    dataProcessing: $dataProcessing
  ) {
    id
  }
}
    `;
export type AcceptLegalTermsMutationFn = ApolloReactCommon.MutationFunction<AcceptLegalTermsMutation, AcceptLegalTermsMutationVariables>;

/**
 * __useAcceptLegalTermsMutation__
 *
 * To run a mutation, you first call `useAcceptLegalTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLegalTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLegalTermsMutation, { data, loading, error }] = useAcceptLegalTermsMutation({
 *   variables: {
 *      termsAndConditions: // value for 'termsAndConditions'
 *      dataProcessing: // value for 'dataProcessing'
 *   },
 * });
 */
export function useAcceptLegalTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptLegalTermsMutation, AcceptLegalTermsMutationVariables>) {
        return ApolloReactHooks.useMutation<AcceptLegalTermsMutation, AcceptLegalTermsMutationVariables>(AcceptLegalTermsDocument, baseOptions);
      }
export type AcceptLegalTermsMutationHookResult = ReturnType<typeof useAcceptLegalTermsMutation>;
export type AcceptLegalTermsMutationResult = ApolloReactCommon.MutationResult<AcceptLegalTermsMutation>;
export type AcceptLegalTermsMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptLegalTermsMutation, AcceptLegalTermsMutationVariables>;
export const ConfirmIdentityAdminDocument = gql`
    mutation ConfirmIdentityAdmin($bank: String!, $brand: String!) {
  confirmIdentityAdmin(brand: $brand, bank: $bank) {
    access
    user {
      id
    }
  }
}
    `;
export type ConfirmIdentityAdminMutationFn = ApolloReactCommon.MutationFunction<ConfirmIdentityAdminMutation, ConfirmIdentityAdminMutationVariables>;

/**
 * __useConfirmIdentityAdminMutation__
 *
 * To run a mutation, you first call `useConfirmIdentityAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIdentityAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIdentityAdminMutation, { data, loading, error }] = useConfirmIdentityAdminMutation({
 *   variables: {
 *      bank: // value for 'bank'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useConfirmIdentityAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmIdentityAdminMutation, ConfirmIdentityAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmIdentityAdminMutation, ConfirmIdentityAdminMutationVariables>(ConfirmIdentityAdminDocument, baseOptions);
      }
export type ConfirmIdentityAdminMutationHookResult = ReturnType<typeof useConfirmIdentityAdminMutation>;
export type ConfirmIdentityAdminMutationResult = ApolloReactCommon.MutationResult<ConfirmIdentityAdminMutation>;
export type ConfirmIdentityAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmIdentityAdminMutation, ConfirmIdentityAdminMutationVariables>;
export const ConfirmIdentityDeepLinkDocument = gql`
    mutation ConfirmIdentityDeepLink($userId: String!, $token: String!, $bank: String!) {
  confirmIdentityDeepLink(userId: $userId, token: $token, bank: $bank) {
    access
    user {
      id
    }
  }
}
    `;
export type ConfirmIdentityDeepLinkMutationFn = ApolloReactCommon.MutationFunction<ConfirmIdentityDeepLinkMutation, ConfirmIdentityDeepLinkMutationVariables>;

/**
 * __useConfirmIdentityDeepLinkMutation__
 *
 * To run a mutation, you first call `useConfirmIdentityDeepLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIdentityDeepLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIdentityDeepLinkMutation, { data, loading, error }] = useConfirmIdentityDeepLinkMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      token: // value for 'token'
 *      bank: // value for 'bank'
 *   },
 * });
 */
export function useConfirmIdentityDeepLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmIdentityDeepLinkMutation, ConfirmIdentityDeepLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmIdentityDeepLinkMutation, ConfirmIdentityDeepLinkMutationVariables>(ConfirmIdentityDeepLinkDocument, baseOptions);
      }
export type ConfirmIdentityDeepLinkMutationHookResult = ReturnType<typeof useConfirmIdentityDeepLinkMutation>;
export type ConfirmIdentityDeepLinkMutationResult = ApolloReactCommon.MutationResult<ConfirmIdentityDeepLinkMutation>;
export type ConfirmIdentityDeepLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmIdentityDeepLinkMutation, ConfirmIdentityDeepLinkMutationVariables>;
export const ConfirmIdentityEmailDocument = gql`
    mutation ConfirmIdentityEmail($value: String!, $brand: String!, $bank: String!, $termsAndConditions: Boolean!, $dataProcessing: Boolean!) {
  confirmIdentityEmail(
    value: $value
    brand: $brand
    bank: $bank
    termsAndConditions: $termsAndConditions
    dataProcessing: $dataProcessing
  ) {
    access
    user {
      id
    }
  }
}
    `;
export type ConfirmIdentityEmailMutationFn = ApolloReactCommon.MutationFunction<ConfirmIdentityEmailMutation, ConfirmIdentityEmailMutationVariables>;

/**
 * __useConfirmIdentityEmailMutation__
 *
 * To run a mutation, you first call `useConfirmIdentityEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIdentityEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIdentityEmailMutation, { data, loading, error }] = useConfirmIdentityEmailMutation({
 *   variables: {
 *      value: // value for 'value'
 *      brand: // value for 'brand'
 *      bank: // value for 'bank'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      dataProcessing: // value for 'dataProcessing'
 *   },
 * });
 */
export function useConfirmIdentityEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmIdentityEmailMutation, ConfirmIdentityEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmIdentityEmailMutation, ConfirmIdentityEmailMutationVariables>(ConfirmIdentityEmailDocument, baseOptions);
      }
export type ConfirmIdentityEmailMutationHookResult = ReturnType<typeof useConfirmIdentityEmailMutation>;
export type ConfirmIdentityEmailMutationResult = ApolloReactCommon.MutationResult<ConfirmIdentityEmailMutation>;
export type ConfirmIdentityEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmIdentityEmailMutation, ConfirmIdentityEmailMutationVariables>;
export const ConfirmIdentityOneTimeLinkDocument = gql`
    mutation ConfirmIdentityOneTimeLink($id: String!) {
  confirmIdentityOneTimeLink(id: $id) {
    access
    user {
      id
    }
  }
}
    `;
export type ConfirmIdentityOneTimeLinkMutationFn = ApolloReactCommon.MutationFunction<ConfirmIdentityOneTimeLinkMutation, ConfirmIdentityOneTimeLinkMutationVariables>;

/**
 * __useConfirmIdentityOneTimeLinkMutation__
 *
 * To run a mutation, you first call `useConfirmIdentityOneTimeLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIdentityOneTimeLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIdentityOneTimeLinkMutation, { data, loading, error }] = useConfirmIdentityOneTimeLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmIdentityOneTimeLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmIdentityOneTimeLinkMutation, ConfirmIdentityOneTimeLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmIdentityOneTimeLinkMutation, ConfirmIdentityOneTimeLinkMutationVariables>(ConfirmIdentityOneTimeLinkDocument, baseOptions);
      }
export type ConfirmIdentityOneTimeLinkMutationHookResult = ReturnType<typeof useConfirmIdentityOneTimeLinkMutation>;
export type ConfirmIdentityOneTimeLinkMutationResult = ApolloReactCommon.MutationResult<ConfirmIdentityOneTimeLinkMutation>;
export type ConfirmIdentityOneTimeLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmIdentityOneTimeLinkMutation, ConfirmIdentityOneTimeLinkMutationVariables>;
export const CreateNegotiationDocument = gql`
    mutation CreateNegotiation($outDebtId: String!, $bank: String!, $negotiationOption: InputNegotiationOption!, $negotiationType: String!, $alternative: InputNegotiationOptionAlternative!, $extraInfo: InputNegotiationExtraInfo!) {
  createNegotiation(
    outDebtId: $outDebtId
    bank: $bank
    negotiationOption: $negotiationOption
    negotiationType: $negotiationType
    alternative: $alternative
    extraInfo: $extraInfo
  ) {
    id
    type
    outDebtId
    bank
    state
  }
}
    `;
export type CreateNegotiationMutationFn = ApolloReactCommon.MutationFunction<CreateNegotiationMutation, CreateNegotiationMutationVariables>;

/**
 * __useCreateNegotiationMutation__
 *
 * To run a mutation, you first call `useCreateNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNegotiationMutation, { data, loading, error }] = useCreateNegotiationMutation({
 *   variables: {
 *      outDebtId: // value for 'outDebtId'
 *      bank: // value for 'bank'
 *      negotiationOption: // value for 'negotiationOption'
 *      negotiationType: // value for 'negotiationType'
 *      alternative: // value for 'alternative'
 *      extraInfo: // value for 'extraInfo'
 *   },
 * });
 */
export function useCreateNegotiationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNegotiationMutation, CreateNegotiationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNegotiationMutation, CreateNegotiationMutationVariables>(CreateNegotiationDocument, baseOptions);
      }
export type CreateNegotiationMutationHookResult = ReturnType<typeof useCreateNegotiationMutation>;
export type CreateNegotiationMutationResult = ApolloReactCommon.MutationResult<CreateNegotiationMutation>;
export type CreateNegotiationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNegotiationMutation, CreateNegotiationMutationVariables>;
export const DeleteExpiredNegotiationDocument = gql`
    mutation DeleteExpiredNegotiation($negotiationId: String!) {
  deleteExpiredNegotiation(negotiationId: $negotiationId)
}
    `;
export type DeleteExpiredNegotiationMutationFn = ApolloReactCommon.MutationFunction<DeleteExpiredNegotiationMutation, DeleteExpiredNegotiationMutationVariables>;

/**
 * __useDeleteExpiredNegotiationMutation__
 *
 * To run a mutation, you first call `useDeleteExpiredNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpiredNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpiredNegotiationMutation, { data, loading, error }] = useDeleteExpiredNegotiationMutation({
 *   variables: {
 *      negotiationId: // value for 'negotiationId'
 *   },
 * });
 */
export function useDeleteExpiredNegotiationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExpiredNegotiationMutation, DeleteExpiredNegotiationMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteExpiredNegotiationMutation, DeleteExpiredNegotiationMutationVariables>(DeleteExpiredNegotiationDocument, baseOptions);
      }
export type DeleteExpiredNegotiationMutationHookResult = ReturnType<typeof useDeleteExpiredNegotiationMutation>;
export type DeleteExpiredNegotiationMutationResult = ApolloReactCommon.MutationResult<DeleteExpiredNegotiationMutation>;
export type DeleteExpiredNegotiationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteExpiredNegotiationMutation, DeleteExpiredNegotiationMutationVariables>;
export const GetOutDebtNegotiationOptionsDocument = gql`
    query GetOutDebtNegotiationOptions($debtId: String!, $gracePeriod: Float, $prePayment: Float, $declaredIncome: Float, $declaredPaymentCapacity: Float) {
  outDebtNegotiationOptions(
    id: $debtId
    gracePeriod: $gracePeriod
    prePayment: $prePayment
    declaredIncome: $declaredIncome
    declaredPaymentCapacity: $declaredPaymentCapacity
  ) {
    type
    rate
    availableGracePeriods
    available
    autoContinue
    extraConfirmationInfo
    isPreCalculated
    alternatives {
      term
      value
      gracePeriod
      balance
      discountValue
      discountPercent
      realDiscountValue
      realDiscountPercent
      currency
      available
      prePayment
      hidden
      type
      commissionPercent
      commissionValue
      totalAmountToPay
      isSpecialCampaign
      isCustomNegotiation
      interestsRate
      effectiveAnnualRate
      discountMora
      extracupo
      totalInitialPayment
    }
    settings {
      min
      max
      step
      maxPaymentDate
      parentOptionDebt
      isShortcutToParent
      isDocumentalTermExtension
    }
  }
}
    `;

/**
 * __useGetOutDebtNegotiationOptionsQuery__
 *
 * To run a query within a React component, call `useGetOutDebtNegotiationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutDebtNegotiationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutDebtNegotiationOptionsQuery({
 *   variables: {
 *      debtId: // value for 'debtId'
 *      gracePeriod: // value for 'gracePeriod'
 *      prePayment: // value for 'prePayment'
 *      declaredIncome: // value for 'declaredIncome'
 *      declaredPaymentCapacity: // value for 'declaredPaymentCapacity'
 *   },
 * });
 */
export function useGetOutDebtNegotiationOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOutDebtNegotiationOptionsQuery, GetOutDebtNegotiationOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOutDebtNegotiationOptionsQuery, GetOutDebtNegotiationOptionsQueryVariables>(GetOutDebtNegotiationOptionsDocument, baseOptions);
      }
export function useGetOutDebtNegotiationOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOutDebtNegotiationOptionsQuery, GetOutDebtNegotiationOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOutDebtNegotiationOptionsQuery, GetOutDebtNegotiationOptionsQueryVariables>(GetOutDebtNegotiationOptionsDocument, baseOptions);
        }
export type GetOutDebtNegotiationOptionsQueryHookResult = ReturnType<typeof useGetOutDebtNegotiationOptionsQuery>;
export type GetOutDebtNegotiationOptionsLazyQueryHookResult = ReturnType<typeof useGetOutDebtNegotiationOptionsLazyQuery>;
export type GetOutDebtNegotiationOptionsQueryResult = ApolloReactCommon.QueryResult<GetOutDebtNegotiationOptionsQuery, GetOutDebtNegotiationOptionsQueryVariables>;
export const GetIdentityConfirmationOptionsDocument = gql`
    query GetIdentityConfirmationOptions($brand: String!, $bank: String!) {
  identityConfirmationOptions(brand: $brand, bank: $bank) {
    id
    type
    value
    values
    bank
    remainingAttempts
    attemptsExhausted
  }
}
    `;

/**
 * __useGetIdentityConfirmationOptionsQuery__
 *
 * To run a query within a React component, call `useGetIdentityConfirmationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentityConfirmationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentityConfirmationOptionsQuery({
 *   variables: {
 *      brand: // value for 'brand'
 *      bank: // value for 'bank'
 *   },
 * });
 */
export function useGetIdentityConfirmationOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIdentityConfirmationOptionsQuery, GetIdentityConfirmationOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetIdentityConfirmationOptionsQuery, GetIdentityConfirmationOptionsQueryVariables>(GetIdentityConfirmationOptionsDocument, baseOptions);
      }
export function useGetIdentityConfirmationOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIdentityConfirmationOptionsQuery, GetIdentityConfirmationOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetIdentityConfirmationOptionsQuery, GetIdentityConfirmationOptionsQueryVariables>(GetIdentityConfirmationOptionsDocument, baseOptions);
        }
export type GetIdentityConfirmationOptionsQueryHookResult = ReturnType<typeof useGetIdentityConfirmationOptionsQuery>;
export type GetIdentityConfirmationOptionsLazyQueryHookResult = ReturnType<typeof useGetIdentityConfirmationOptionsLazyQuery>;
export type GetIdentityConfirmationOptionsQueryResult = ApolloReactCommon.QueryResult<GetIdentityConfirmationOptionsQuery, GetIdentityConfirmationOptionsQueryVariables>;
export const GetOneTimeLinkDocument = gql`
    query GetOneTimeLink($id: String!) {
  getOneTimeLink(id: $id) {
    payload {
      redirectTo
      brand
      country
      bank
    }
  }
}
    `;

/**
 * __useGetOneTimeLinkQuery__
 *
 * To run a query within a React component, call `useGetOneTimeLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneTimeLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneTimeLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOneTimeLinkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOneTimeLinkQuery, GetOneTimeLinkQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOneTimeLinkQuery, GetOneTimeLinkQueryVariables>(GetOneTimeLinkDocument, baseOptions);
      }
export function useGetOneTimeLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOneTimeLinkQuery, GetOneTimeLinkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOneTimeLinkQuery, GetOneTimeLinkQueryVariables>(GetOneTimeLinkDocument, baseOptions);
        }
export type GetOneTimeLinkQueryHookResult = ReturnType<typeof useGetOneTimeLinkQuery>;
export type GetOneTimeLinkLazyQueryHookResult = ReturnType<typeof useGetOneTimeLinkLazyQuery>;
export type GetOneTimeLinkQueryResult = ApolloReactCommon.QueryResult<GetOneTimeLinkQuery, GetOneTimeLinkQueryVariables>;
export const GetOutDebtsDocument = gql`
    query GetOutDebts {
  outDebts {
    ...outDebtFields
  }
}
    ${OutDebtFieldsFragmentDoc}`;

/**
 * __useGetOutDebtsQuery__
 *
 * To run a query within a React component, call `useGetOutDebtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutDebtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutDebtsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOutDebtsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOutDebtsQuery, GetOutDebtsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOutDebtsQuery, GetOutDebtsQueryVariables>(GetOutDebtsDocument, baseOptions);
      }
export function useGetOutDebtsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOutDebtsQuery, GetOutDebtsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOutDebtsQuery, GetOutDebtsQueryVariables>(GetOutDebtsDocument, baseOptions);
        }
export type GetOutDebtsQueryHookResult = ReturnType<typeof useGetOutDebtsQuery>;
export type GetOutDebtsLazyQueryHookResult = ReturnType<typeof useGetOutDebtsLazyQuery>;
export type GetOutDebtsQueryResult = ApolloReactCommon.QueryResult<GetOutDebtsQuery, GetOutDebtsQueryVariables>;
export const GetProductNumberDefDocument = gql`
    query GetProductNumberDef($outDebtId: String!) {
  getProductNumberDef(outDebtId: $outDebtId)
}
    `;

/**
 * __useGetProductNumberDefQuery__
 *
 * To run a query within a React component, call `useGetProductNumberDefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductNumberDefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductNumberDefQuery({
 *   variables: {
 *      outDebtId: // value for 'outDebtId'
 *   },
 * });
 */
export function useGetProductNumberDefQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductNumberDefQuery, GetProductNumberDefQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductNumberDefQuery, GetProductNumberDefQueryVariables>(GetProductNumberDefDocument, baseOptions);
      }
export function useGetProductNumberDefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductNumberDefQuery, GetProductNumberDefQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductNumberDefQuery, GetProductNumberDefQueryVariables>(GetProductNumberDefDocument, baseOptions);
        }
export type GetProductNumberDefQueryHookResult = ReturnType<typeof useGetProductNumberDefQuery>;
export type GetProductNumberDefLazyQueryHookResult = ReturnType<typeof useGetProductNumberDefLazyQuery>;
export type GetProductNumberDefQueryResult = ApolloReactCommon.QueryResult<GetProductNumberDefQuery, GetProductNumberDefQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile {
  profile {
    ...profileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, baseOptions);
      }
export function useGetProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, baseOptions);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = ApolloReactCommon.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetSettingDocument = gql`
    query GetSetting($name: String!) {
  setting(name: $name) {
    finalAssignmentDate {
      bank
      brand
      regularDate
      prePunishedDate
      description
      maxValidPaymentDate
    }
    legalAcceptanceVersion {
      termsAndConditions
      dataProcessingPolicy
    }
    globalSettingByEntity {
      entitySelector {
        brand
        bank
        country
      }
      domainWhatsapp {
        number
        formattedNumber
      }
      domainCalls {
        number
        formattedNumber
      }
    }
  }
}
    `;

/**
 * __useGetSettingQuery__
 *
 * To run a query within a React component, call `useGetSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSettingQuery, GetSettingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSettingQuery, GetSettingQueryVariables>(GetSettingDocument, baseOptions);
      }
export function useGetSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSettingQuery, GetSettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSettingQuery, GetSettingQueryVariables>(GetSettingDocument, baseOptions);
        }
export type GetSettingQueryHookResult = ReturnType<typeof useGetSettingQuery>;
export type GetSettingLazyQueryHookResult = ReturnType<typeof useGetSettingLazyQuery>;
export type GetSettingQueryResult = ApolloReactCommon.QueryResult<GetSettingQuery, GetSettingQueryVariables>;
export const NewTwilioPhoneVerificationDocument = gql`
    mutation NewTwilioPhoneVerification($phone: String, $digits: String, $type: String) {
  newTwilioPhoneVerification(phone: $phone, digits: $digits, type: $type) {
    state
    code
    type
  }
}
    `;
export type NewTwilioPhoneVerificationMutationFn = ApolloReactCommon.MutationFunction<NewTwilioPhoneVerificationMutation, NewTwilioPhoneVerificationMutationVariables>;

/**
 * __useNewTwilioPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useNewTwilioPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewTwilioPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newTwilioPhoneVerificationMutation, { data, loading, error }] = useNewTwilioPhoneVerificationMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      digits: // value for 'digits'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useNewTwilioPhoneVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NewTwilioPhoneVerificationMutation, NewTwilioPhoneVerificationMutationVariables>) {
        return ApolloReactHooks.useMutation<NewTwilioPhoneVerificationMutation, NewTwilioPhoneVerificationMutationVariables>(NewTwilioPhoneVerificationDocument, baseOptions);
      }
export type NewTwilioPhoneVerificationMutationHookResult = ReturnType<typeof useNewTwilioPhoneVerificationMutation>;
export type NewTwilioPhoneVerificationMutationResult = ApolloReactCommon.MutationResult<NewTwilioPhoneVerificationMutation>;
export type NewTwilioPhoneVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<NewTwilioPhoneVerificationMutation, NewTwilioPhoneVerificationMutationVariables>;
export const TwilioPhoneVerificationDocument = gql`
    mutation TwilioPhoneVerification($code: String!, $brand: String!, $bank: String!, $termsAndConditions: Boolean!, $dataProcessing: Boolean!) {
  twilioPhoneVerification(
    code: $code
    brand: $brand
    bank: $bank
    termsAndConditions: $termsAndConditions
    dataProcessing: $dataProcessing
  ) {
    access
    user {
      id
      phone
    }
  }
}
    `;
export type TwilioPhoneVerificationMutationFn = ApolloReactCommon.MutationFunction<TwilioPhoneVerificationMutation, TwilioPhoneVerificationMutationVariables>;

/**
 * __useTwilioPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useTwilioPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwilioPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twilioPhoneVerificationMutation, { data, loading, error }] = useTwilioPhoneVerificationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      brand: // value for 'brand'
 *      bank: // value for 'bank'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      dataProcessing: // value for 'dataProcessing'
 *   },
 * });
 */
export function useTwilioPhoneVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TwilioPhoneVerificationMutation, TwilioPhoneVerificationMutationVariables>) {
        return ApolloReactHooks.useMutation<TwilioPhoneVerificationMutation, TwilioPhoneVerificationMutationVariables>(TwilioPhoneVerificationDocument, baseOptions);
      }
export type TwilioPhoneVerificationMutationHookResult = ReturnType<typeof useTwilioPhoneVerificationMutation>;
export type TwilioPhoneVerificationMutationResult = ApolloReactCommon.MutationResult<TwilioPhoneVerificationMutation>;
export type TwilioPhoneVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<TwilioPhoneVerificationMutation, TwilioPhoneVerificationMutationVariables>;
export const UnvalidateTwilioVerificationDocument = gql`
    mutation UnvalidateTwilioVerification {
  unvalidateTwilioVerification
}
    `;
export type UnvalidateTwilioVerificationMutationFn = ApolloReactCommon.MutationFunction<UnvalidateTwilioVerificationMutation, UnvalidateTwilioVerificationMutationVariables>;

/**
 * __useUnvalidateTwilioVerificationMutation__
 *
 * To run a mutation, you first call `useUnvalidateTwilioVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnvalidateTwilioVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unvalidateTwilioVerificationMutation, { data, loading, error }] = useUnvalidateTwilioVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnvalidateTwilioVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnvalidateTwilioVerificationMutation, UnvalidateTwilioVerificationMutationVariables>) {
        return ApolloReactHooks.useMutation<UnvalidateTwilioVerificationMutation, UnvalidateTwilioVerificationMutationVariables>(UnvalidateTwilioVerificationDocument, baseOptions);
      }
export type UnvalidateTwilioVerificationMutationHookResult = ReturnType<typeof useUnvalidateTwilioVerificationMutation>;
export type UnvalidateTwilioVerificationMutationResult = ApolloReactCommon.MutationResult<UnvalidateTwilioVerificationMutation>;
export type UnvalidateTwilioVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<UnvalidateTwilioVerificationMutation, UnvalidateTwilioVerificationMutationVariables>;
export const OutDebtsReportDocument = gql`
    query OutDebtsReport {
  outDebtsReport {
    hasSome
    managedBanks {
      brand
      debtManager
      bank
    }
    shouldRedirectToNegotiator
  }
}
    `;

/**
 * __useOutDebtsReportQuery__
 *
 * To run a query within a React component, call `useOutDebtsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutDebtsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutDebtsReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutDebtsReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OutDebtsReportQuery, OutDebtsReportQueryVariables>) {
        return ApolloReactHooks.useQuery<OutDebtsReportQuery, OutDebtsReportQueryVariables>(OutDebtsReportDocument, baseOptions);
      }
export function useOutDebtsReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutDebtsReportQuery, OutDebtsReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OutDebtsReportQuery, OutDebtsReportQueryVariables>(OutDebtsReportDocument, baseOptions);
        }
export type OutDebtsReportQueryHookResult = ReturnType<typeof useOutDebtsReportQuery>;
export type OutDebtsReportLazyQueryHookResult = ReturnType<typeof useOutDebtsReportLazyQuery>;
export type OutDebtsReportQueryResult = ApolloReactCommon.QueryResult<OutDebtsReportQuery, OutDebtsReportQueryVariables>;
export const UpdateMaxPaymentDateExpiredNegotiationDocument = gql`
    mutation UpdateMaxPaymentDateExpiredNegotiation($negotiationId: String!, $maxPaymentDate: DateTime!) {
  updateMaxPaymentDateExpiredNegotiation(
    negotiationId: $negotiationId
    maxPaymentDate: $maxPaymentDate
  )
}
    `;
export type UpdateMaxPaymentDateExpiredNegotiationMutationFn = ApolloReactCommon.MutationFunction<UpdateMaxPaymentDateExpiredNegotiationMutation, UpdateMaxPaymentDateExpiredNegotiationMutationVariables>;

/**
 * __useUpdateMaxPaymentDateExpiredNegotiationMutation__
 *
 * To run a mutation, you first call `useUpdateMaxPaymentDateExpiredNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaxPaymentDateExpiredNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaxPaymentDateExpiredNegotiationMutation, { data, loading, error }] = useUpdateMaxPaymentDateExpiredNegotiationMutation({
 *   variables: {
 *      negotiationId: // value for 'negotiationId'
 *      maxPaymentDate: // value for 'maxPaymentDate'
 *   },
 * });
 */
export function useUpdateMaxPaymentDateExpiredNegotiationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMaxPaymentDateExpiredNegotiationMutation, UpdateMaxPaymentDateExpiredNegotiationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMaxPaymentDateExpiredNegotiationMutation, UpdateMaxPaymentDateExpiredNegotiationMutationVariables>(UpdateMaxPaymentDateExpiredNegotiationDocument, baseOptions);
      }
export type UpdateMaxPaymentDateExpiredNegotiationMutationHookResult = ReturnType<typeof useUpdateMaxPaymentDateExpiredNegotiationMutation>;
export type UpdateMaxPaymentDateExpiredNegotiationMutationResult = ApolloReactCommon.MutationResult<UpdateMaxPaymentDateExpiredNegotiationMutation>;
export type UpdateMaxPaymentDateExpiredNegotiationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMaxPaymentDateExpiredNegotiationMutation, UpdateMaxPaymentDateExpiredNegotiationMutationVariables>;
export const UpdatePhoneDocument = gql`
    mutation UpdatePhone($phone: String!) {
  updatePhone(phone: $phone)
}
    `;
export type UpdatePhoneMutationFn = ApolloReactCommon.MutationFunction<UpdatePhoneMutation, UpdatePhoneMutationVariables>;

/**
 * __useUpdatePhoneMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneMutation, { data, loading, error }] = useUpdatePhoneMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdatePhoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhoneMutation, UpdatePhoneMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhoneMutation, UpdatePhoneMutationVariables>(UpdatePhoneDocument, baseOptions);
      }
export type UpdatePhoneMutationHookResult = ReturnType<typeof useUpdatePhoneMutation>;
export type UpdatePhoneMutationResult = ApolloReactCommon.MutationResult<UpdatePhoneMutation>;
export type UpdatePhoneMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhoneMutation, UpdatePhoneMutationVariables>;
export const NewWaChatEventDocument = gql`
    mutation newWaChatEvent {
  newWaChatEvent
}
    `;
export type NewWaChatEventMutationFn = ApolloReactCommon.MutationFunction<NewWaChatEventMutation, NewWaChatEventMutationVariables>;

/**
 * __useNewWaChatEventMutation__
 *
 * To run a mutation, you first call `useNewWaChatEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewWaChatEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newWaChatEventMutation, { data, loading, error }] = useNewWaChatEventMutation({
 *   variables: {
 *   },
 * });
 */
export function useNewWaChatEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NewWaChatEventMutation, NewWaChatEventMutationVariables>) {
        return ApolloReactHooks.useMutation<NewWaChatEventMutation, NewWaChatEventMutationVariables>(NewWaChatEventDocument, baseOptions);
      }
export type NewWaChatEventMutationHookResult = ReturnType<typeof useNewWaChatEventMutation>;
export type NewWaChatEventMutationResult = ApolloReactCommon.MutationResult<NewWaChatEventMutation>;
export type NewWaChatEventMutationOptions = ApolloReactCommon.BaseMutationOptions<NewWaChatEventMutation, NewWaChatEventMutationVariables>;
export const ConfirmIdentityCcNumberDocument = gql`
    mutation ConfirmIdentityCCNumber($digits: String!, $brand: String!, $bank: String!, $termsAndConditions: Boolean!, $dataProcessing: Boolean!) {
  confirmIdentityCCNumber(
    digits: $digits
    brand: $brand
    bank: $bank
    termsAndConditions: $termsAndConditions
    dataProcessing: $dataProcessing
  ) {
    access
    user {
      id
    }
  }
}
    `;
export type ConfirmIdentityCcNumberMutationFn = ApolloReactCommon.MutationFunction<ConfirmIdentityCcNumberMutation, ConfirmIdentityCcNumberMutationVariables>;

/**
 * __useConfirmIdentityCcNumberMutation__
 *
 * To run a mutation, you first call `useConfirmIdentityCcNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIdentityCcNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIdentityCcNumberMutation, { data, loading, error }] = useConfirmIdentityCcNumberMutation({
 *   variables: {
 *      digits: // value for 'digits'
 *      brand: // value for 'brand'
 *      bank: // value for 'bank'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      dataProcessing: // value for 'dataProcessing'
 *   },
 * });
 */
export function useConfirmIdentityCcNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmIdentityCcNumberMutation, ConfirmIdentityCcNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmIdentityCcNumberMutation, ConfirmIdentityCcNumberMutationVariables>(ConfirmIdentityCcNumberDocument, baseOptions);
      }
export type ConfirmIdentityCcNumberMutationHookResult = ReturnType<typeof useConfirmIdentityCcNumberMutation>;
export type ConfirmIdentityCcNumberMutationResult = ApolloReactCommon.MutationResult<ConfirmIdentityCcNumberMutation>;
export type ConfirmIdentityCcNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmIdentityCcNumberMutation, ConfirmIdentityCcNumberMutationVariables>;